const English = {
  messages: {
    currency: 'R.S',
    rent: "For Rent",
    sale: "For Sale",
    investment: "For Investment",
    prev: 'Previous',
    next: 'Next',
    validateMessage: "This field is required",
    area: "M",
    confirm_title: "Do you definitely want to delete the property?",
    confirmButtonText: "delete",
    cancelButtonText: "cancellation",
    confirmMessage: "The property was successfully deleted",
    date_Message: "The date must be selected",
    time_Message: "The time must be selected",
    image_Title: "Do you want to confirm the image deletion?",
    success_Message: "The image was successfully deleted",
    ownerPhone_Message: "The owner's mobile number is incorrect",
    ownerIdentity_Message: "The owner's ID number is incorrect",
    identityNumber: "Invalid ID number",
    receiptNumber_Message:  "receipt Number required",
    agentIdentity_Message: "The agent's ID number is incorrect",
    agencyNumber_Message: "The agency number is incorrect",
    agentMobile_Message:  "The agent's mobile number is incorrect",
    propertyAdd_Title:  "The brief description must be entered correctly",
    mobile_Message: "Incorrect mobile number",
    request_submitted : "A request for contract notarization was submitted",
    totalPrice: "Total Price",
    priceDiscount: "Price after discount",
    walletPaymentConfirmation: "Wallet payment confirmation",
    walletBalance: "Wallet balance",
    totalOrder: "total Order",
    remainingBalance: "remaining Balance",
    confirmButton: "confirmation",
    balanceInsufficient: "Your wallet balance is currently insufficient!",
    chargeWallet: "Please charge wallet first",
    btnChargeWallet: "Charge your wallet",
    errorOccurred: " Error occurred",
    regionFirst: "Please select your region first",
    cityFirst: "Please select the city first.",
    continuation: "Continuation",
    selectRegion: "Select Region",
    selectCity: "Select City",
    selectNeighborhood: "Select Neighborhood",
    shareApps: "Share the app and earn 1000 riyals!",
    share_Amazing: "Share your referral link with 100 friends and get 10 riyals for every new user who registers through your link.",
    button_ShareNow: "Share the app now!",
    Free_owners_tenants: "Public facility maintenance requests",
    dedicated_Maintenance: "No upfront payment is required; the amount can be settled later with the landlord or tenant.",
    requestMaintenance: "Request new maintenance",
    Within_24hours: "Within 24 hours, starting at ",
    requestExpress_maintenance: "Request express maintenance",
    Within_120Minutes: "Within 120 minutes, starting at ",
    contactLawyer: "Contact your lawyer",
    lawyerNow: "Contact your lawyer now for the amount",
    needFinancing: "Do you need financing to make your obligations easier and give",
    manageObligations: "Do you need to manage your obligations more easily and comfortably?",
    ApplyFnancing: "Apply for your financing now.",
    areaSymbol: "2m",
    invoiceDetails: "Invoice display",
    incorrectMobile: "Incorrect mobile number",
    Ahmed_AlMuhaisni: "Ahmed Al-Muhaisni Real Estate",
    payRent: "Pay your rent",
    // requestMaintenance: "Request maintenance",
    customers: "Customers",
    contactService: "Contact service",
    SpeakcustomerService: "Speak to customer service",
    cancelMaintenance: "Cancel maintenance request",
    close: "Close chat",
    closing: "closing",
    searchingTechnician: "We are currently searching for a technician in your area!",
    TrackRequest: "Track your request",
    send: "send",
    unknown: "Unknown",
    maintenanceMosques: "Free maintenance of mosques 🕌",
    godsMosques: "By submitting a maintenance request, you contribute to the upkeep of mosques.",
    trackOrders: "Track orders",
    propertyFeatures: "Property Features",
    viewAll: "View all",
    commercial: "Commercial",
    residential: "Residential",
    from: "From",
    to: "To",
    Invite_Friends: "Invite your friends and earn up to",
    invite_P: "A riyal in your wallet",
    invite_NewFriend: "You'll receive a reward every time you invite a new friend to begin their journey with",
    Real_EstateInvestment: "Real Estate Investment",
    shareInvitationLink: "Share your invitation link",
    hopeLocation: "We hope the location below matches the location mentioned in the written property description.",
    ReliableInformation: "Reliable information from the General Authority for Real Estate",
    adLicenseNumber: "adLicenseNumber",
    creationDate: "creationDate",
    furnished: "Furnished",
    shareApps_price: "Share the app and earn credit",
    inviteFriends_register: "Invite your friends to register via your link, and get",
    riyals_Yourwallet: "Riyals in your wallet for every new user who registers through your invitation.",
    serviceUnavailable: "This service is currently unavailable in your area!",
    workingExpanding: "We're working on expanding it soon, and you'll be notified as soon as the service becomes available.",
    availableProperties: "Browse available properties",
    discountCoupon: "Do you have a discount coupon?",
    getDiscount: "Get a discount when you use the code: FirstAM when completing your purchase. Don't miss the opportunity to save more on your purchase!",
    couponCode: "Enter the coupon code",
    application: "application",
    price_beforeDiscount: "Price before discount",
    priceAfterDiscount: "Price after discount",
    DiscussLegal: "Discuss all the legal aspects of your property.",
    participateWin: "Participate and win",
    reliableMaintenance: "Reliable maintenance solutions with the highest quality standards",
    realEstateBulletin: "Real Estate Bulletin",
    latestRealEstate_Updates: "Latest real estate news and updates",
    exampleServiceDescription: "Example of service description: To buy a plot of land to build your home, this requires documenting the buying and selling process in documentation offices or services",
    notaryPublic: "The notary public will register the property in your name.",
    publishedIn: "Published in",
    viewFile: "View file",
    download: "download",
    realEstateBulletin_Details: "realEstateBulletin Details",
    investmentProperty: "Return on investment for the property",
    oldestNewest: "From oldest to newest",
    newestOldest: "From newest to oldest",
    sendPrice: "Send your price",
    technicianChange_received: "Technician change request received",
    sendingAnother_suitable: "We are now working on sending another suitable technician to you as soon as possible.",
    soonPossible: "As soon as possible. Thank you for your patience 🙏",
    thanks: 'Thanks',
    homepage: "Return to homepage",
    dataAvailable: "No data available",
    successfullyPaid: "The installment due was successfully paid.",
    sendReply: "Send a reply",
    detailsLegalinquiry: "Write the details of your legal inquiry here...",
    receivedReply: "We received the reply successfully",
    viewDocuments: "View document",
    subscriptionPackages: 'Subscription packages',
    target: "Target",
    homeowners: "Homeowners",
    apartmentOwners: "Apartment and villa owners",
    featuresIncluded: "Features included",
    termsConditions: "Package Terms and Conditions",
    packageDetails: "View package details",
    subscriptionPackage_Details: "Subscription package details",
    package_Controlpanel: "Package control panel",
    valuedPartner: "Welcome, our valued partner",
    recentActivity: "Recent activity",
    manageCurrent_plan: "Manage your current plan",
    featuresCurrent: "You have consumed a large part of the features of the current package. Upgrade your package now to get more space and additional ads to grow your business faster.",
    consumptionRate: "Real estate consumption rate",
    userConsumption: "User consumption rate",
    packageRenewal: "Package renewal",
    renewal: "renewal:",
    Inactive: "Inactive",
    maintenance_Followup: "Maintenance follow-up",
    maintenanceSystem: "Maintenance system",
    subscribeNow: "Subscribe now",
    smartControlPanel: "Smart Control Panel",
    homeMaintenance: "Home Maintenance Package",
    annually: "/ annually",
    discountPercentage: "discount Percentage",
    visitsCount: "visits Count",
    usedVisits: "Used visits",
    ordersReceived: "Recent orders received",
    viewAllRequests: "View all requests",
    maintenanceDetailslocation: "Maintenance details and location",
    orderNumber: "Order number",
    orderStatus: "Order status",
    orderDate: "Order date",
    procedure: "Procedure",
    messageTex: "Subscription successful",
    nothing: "nothing",
    myAccount: "My account",
    myPersonal: "My personal account details",
    accountDetails: "Account details",
    currentAccount: "Current account type",
    personalAccount: "personal account",
    change_AccountType: "Change account type",
    controlPanel: "Control panel",
    previews: "Previews",
    realEstate_Comparison: "RealEstate Comparison",
    myAccount: "My account",
    billboardOpposite: "Would you like to hang a billboard opposite",
    chooseBoard_size: "Choose banner size",
    maintenancePackages: "Maintenance packages",
    propertyPackages: "Property Packages",
    realEstate_FinancingRequest: "Real estate financing request",
    requestProperty: "Request a property",
    myrentals: "My rentals",
    applicant: "Applicant",
    transferProject: "transfer Project",
    propertiesNear_you: "Properties near you",
    passwordRecovery: "Password recovery",
    rentedOut: "Rented out",
    Sold: "Sold",
    PropertyAge: "Property age",
    addingNotes: "Adding notes",
    editAccount_Details: "Edit account details",
    mobileNumber_required: "Mobile number is required",
    mobileNumber_displayed: "The mobile number to be displayed on the sign",
    customer_ServiceMessage: "Peace, mercy, and blessings of God be upon you,I came across your advertisement on the Al-Muhaisni Real Estate app. I would like to speak with a customer service specialist to learn more about your real estate services and the available options, and to discuss how they might align with my current needs.Thank you, and I look forward to hearing from you.",
    invitationCode: "Do you have an invitation code from a friend?",
    enter_InvitationCode: "Enter the invitation code",
    privacy_Policy: "By creating an account, you agree to the terms and privacy policy.",
    selectBannersize: "Please select the banner size for the board first.",
    perfectHome: "Find the perfect home",
    easily: "easily",
    realEstate_Offerings: "Explore the latest real estate offerings in the Kingdom—including apartments, villas, and land—and stay up to date with the latest developments from reliable sources, all in one place.",
    realEstate_platform: "Unified real estate platform",
    certifiedAgents: "Certified agents",
    dailyUpdates: "Daily updates",
    overProperties: "Over 120,000 properties",
    changingStatus: "Changing the status of your property",
    select_PropertyStatus: "Select your property's status",
    btn_Sold: "Sold",
    btn_Rented: "rented",
    btn_underReview: "Under review",
    propertyStatuschanged: "property status has been changed",
    returnMyads: "Return to my ads",
    paylater: "Rent now and pay later, starting",
    rialsMonth: "Rials per month",
    rentNow: "Rent now",
    nav: {
      home: 'Home',
      about: 'AboutUs',
      map: 'Map',
      Addadvertisement: 'Addadvertisement',
      properties: 'Property Management',
      login: "Login/Register",
      myads: 'My Ads',
      wallet: 'Wallet',
      myRequests: 'My Requests',
      myProperty: 'Purchase orders',
      account: 'Account',
      accountDetails: 'Account Details',
      reservations: 'reservations',
      myRents: 'My Rents',
      Previews: 'Previews',
      requestProperty: 'Request Property',
      favoriteProperties: 'Favorite Properties',
      Maintenance: 'Maintenance',
      Payments: 'Payments',
      financialTransactions: 'Financial Transactions',
      bankAccount: 'bank Account',
      More: 'More',
      Blog: 'Blog',
      Settings: 'Settings',
      frequentlyQuestions: 'Frequently Questions',
      Support: 'Support',
      SignOut: 'Sign Out',
      taxCertificate: 'Tax Certificate',
      val_License: 'Val License',
      sharing: 'Sharing',
      notifications: 'Notifications',
      no_Notifications: 'No Notifications',
      logOut: "Log out",
      oneStep: "One step away from ending your journey… Are you",
      twoStep: "Do you really want to stop now?",
      someTimes: "Sometimes, the difference between failure and success is just one decision.",
      buttonContinue: "Continue browsing",
      buttonExit: "Confirm exit",
      guest: "Guest",
      mySubscription: "My Subscription",
      supportChat: 'Contact customer service',
      chatTitle: 'Contact for?',
      chatSend: 'submit',
      chantTitleRequired: 'A brief overview of the communication topic should be written.',
      chats: 'messages',
      customerService: 'customers service',
      chatCantSend: 'Unable to send at this time, please try again later.',
      chatWithClient: 'Contact seller',
      relgoin: 'Unable to send. Please log out and log back in.',
      welcome: 'Welcome',
      inviteFriends: "Invite your friends",
      realEstateServices: "Real Estate Services Center",
      realEstatePublications: "There are no real estate publications at the moment.",
      welcomeBack: "Welcome",
      goto_Profile: "Go to your profile",
    },

    home: {
      h1: "A selection of luxury real estate opportunities.",
      h2: "Carefully selected homes and investments that combine comfort and luxury, giving you the details that suit your lifestyle and aspirations.",
      ft_1: "Areas",
      ft_2: "City",
      ft_3: "Neighborhood",
      ft_4: "Property type",
      fb: "Search",
      ft_5: "Select Area Name",
      ft_6: "Select City",
      ft_7: "Neighborhood",
      ft_8: "Select Property Type",
      banner_h1: "Do you have a property for sale or rent?",
      banner_h2: "Explore our property management service and get the benefits by joining us.",
      banner_b: "Add Property",
      title_1: "Discover Kingdom Properties",
      title_2: "View All",
      title_3: "Properties near you",
      title_4: "Featured properties",
      title_5: "Family-friendly properties",
      title_6: "Real estate for young people",
      title_7: "Are you looking for a property with specifications that suit your needs?",
      title_8: "Submit your request and we will contact you soon.",
      title_9: "Request",
      title_10: "Your property… is under your control",
      title_11: "Increase your property returns and grow your real estate assets, and leave their management to us through our integrated platform.",
      title_12: "Start Now",
      title: "Download the app and join us now",
      Business_Transfer: "Business Transfer Projects",
      maintenanceRequests: "There are maintenance requests",
    },

    about: {
      title: "Overview",
      companyName: "Ahmed Suleiman Bin Hamad Al Muhaisni Real Estate Company",
      text_1: "A leading Saudi real estate services group, Ahmed Al-Muhaisni Real Estate Group is working to keep pace with the Kingdom's ambitious Vision 2030, which lays the foundation for a sustained investment and economic boom. We offer a distinct concept based on scientific foundations and a comprehensive vision for the future when providing various services related to real estate activity, whether in real estate investment services or real estate marketing for commercial, residential, and administrative complexes, as well as in property management and operations.",
      text_2: "Obtaining all necessary accreditations and licenses to practice real estate activities",
      vision: "Vision",
      vision_p:  "To be a leading real estate company in the Kingdom, both on the ground and digitally, in managing, operating, and marketing real estate assets through integrated solutions that enhance efficiency and increase investment value.",
      message:  "Message",
      message_p: "That Ahmed Al-Muhaisni Real Estate Company provides integrated real estate services and solutions supported by technology and governance, contributes to the management, operation and marketing of real estate assets efficiently and reliably, and enhances sustainable value for clients and investors.",
      fieldsWork:  "Fields of work",
      propertyManagement: "Property management",
      real_Estatemarketing: "Real estate marketing",
      ownersUnion: "Owners Union",
      electronicMarketing: "Electronic marketing",
      realEstate_Auctions: "Real estate auctions",
      realEstate_evaluation: "Real estate evaluation",
      Off_PlanSales: "Off-plan sales",
      realEstate_Financing: "Real estate financing",
      legalServices: "Legal services",
      maintenance: "Maintenance",

      title_4: "Property Management",
      text_13: "The Property Management Department, on behalf of the owner, handles all property-related activities to the highest standards, ensuring optimal rental returns, regular follow-up, legal affairs, and legal representation, all under the supervision of the Property Management Team.",
      title_5: "Property management service includes:",
      text_14:  "Maintenance includes:",
      text_15: "Plumbing and Electrical",
      text_16: "Guarding",
      text_17: "Elevator maintenance",
      text_18: "Cleaning work",
      text_19: "Appointing a property supervisor to follow up on tenants and receive maintenance reports.",
      text_20: "Review government agencies",
      text_21: "Municipality - Electricity Company - Water",
      text_22: "Marketing and Leasing",
      text_23: "Social Media Accounts - Sponsored Campaigns - Billboards",
      text_24: "Managing the property owner's tax file.",
      text_25: "Managing and documenting contracts on the Ejar platform.",
      text_26: "the Accounts:",
      text_27: "Collecting rental payments on time through the accounts department",
      text_28: "Periodic update of rental prices according to market prices.",
      text_29: "Confidentiality of information and maintenance of privacy.",
      text_30: "Electronic reports through the website.",
      text_31: "Legal Committee for Court Pleadings for Delinquent Tenants, Fees Paid by Ahmed Al-Muhaisni Real Estate Group.",
      text_32: "Real Estate Marketing (Experience and Skill):",
      text_33: "Speed ​​in sales and providing solutions and advantages to attract the customer. Ahmed Al-Muhaisni Real Estate Group is distinguished by following marketing mechanisms, including:",
      text_34: "Identify property characteristics and competitive advantages",
      text_35: "Professional property photography",
      text_36: "Content preparation and writing",
      text_37: "Develop a marketing plan",
      text_38: "Post and follow ads",
      text_39: "Real Estate appraisal and valuation:",
      text_40: "Tamam offers you an appraisal service according to approved appraisal standards. The value is determined based on the property's specifications, in addition to key market factors and variables. This helps you achieve the best results.",
      text_41: "Data collection and analysis",
      text_42: "Determine market value",
      text_43: "Various evaluation methods",
      text_44: "Study of surrounding properties",
      text_45: "Future vision and market expectations",
      text_46: "Owners Association Management",
      text_47: "Ahmed Al-Muhaisni Real Estate Group has specialists in managing the owners’ association and providing all services and tasks related to it, while providing comfort and security, according to the highest standards that ensure the sustainability of the property.",
      text_48: "Group features",
      text_49: "A distinguished, qualified, experienced and highly efficient work team",
      text_50: "Linking with government and official agencies according to their requirements",
      text_51: "Employing modern technology and techniques",
      text_52: "Obtained the necessary licenses to practice real estate activities",
      text_53: "Using the best systems in property management and maintenance",
      text_54: "Call center to answer customer calls",
      text_55: "For communication and inquiries:",
      comprehensive: "We offer integrated real estate services with a focus on",
      comprehensive_P: "On speed, quality, and transparency",
      propertyManagement: "Property Management",
      realEstate_marketing: "Real estate marketing",
      ownersAssociation: "Owners Association",
      digitalMarketing: "Digital Marketing",
      realEstate_Auctions: "Real estate auctions",
      realEstate_Appraisal: "Real estate appraisal",
      off_plan_sales: "Off-plan sales",
      realEstate_financing: "Real estate financing",
      legalServices: "Legal services",
      maintenance: "Maintenance",
      featuresGroup: "Features of the group",
      distinguishedTeam: "A distinguished team with extensive experience and high efficiency",
      qualifiedRealEstate: "A select group of qualified real estate professionals to guide you towards the best investment options and provide reliable advice.",
      integrationGovernment: "Integration with government and official entities according to their requirements.",
      directTechnical: "Direct technical integration with official platforms and entities in the Kingdom to expedite and facilitate all official procedures and documentation.",
      modernTechnology: "Leveraging modern technology and techniques",
      innovativeTechnologies: "We utilize the latest innovative real estate technologies and artificial intelligence to provide smart search solutions and accurate market analysis.",
      necessaryLicenses: "We hold all the necessary licenses to conduct real estate activities.",
      licensedRegistered: "We are a fully licensed and officially registered establishment, holding all the required permits from the General Authority for Real Estate to operate with complete safety and confidence.",
      bestSystems: "Using the best systems for property management and maintenance",
      advancedCloud_based: "We rely on advanced cloud-based systems for property management and real-time tracking of maintenance requests to ensure the preservation of your assets' value.",
      customer_Callcenter: "Customer call center to answer inquiries",
      comprehensiveSupport: "An integrated support center that works around the clock to answer your inquiries and provide quick technical support in a distinguished, professional manner.",
      interested: "Are you interested?",
      manageProperty: "Do you have an inquiry or would you like to manage your property?",
      contactSpecialized: "We are happy for you to contact our specialized customer service team within moments to obtain the best real estate consultation.",
      dedicatedCustomer: "We are pleased to connect you with our dedicated customer service team, who will be available in moments to provide you with the best real estate advice.",
      phone_WhatsApp: "Phone/WhatsApp",
      phoneNumber: "0535000304",
      email: "Email:",
      address: "Location",
      location: "Kingdom of Saudi Arabia",
      contactNow: "Contact us now",
      aboutTeam: 'Learn more about the team',
      Who_are_we: "Who are we",
      methodologyAttention: "We work with a sound methodology and attention to detail.",
    },

    map: {
      breadcrumb_1: "Home",
      breadcrumb_2: "Map",
      title: "The Site",
      btnAll: "All",
      btnSale: "For rent",
      btnRent: "For sale",
      accessLocation: 'We need access to your location so we can display the properties on the map.',
    },

    addAd: {
      breadcrumb_1: "Home",
      breadcrumb_2: "Advertisment",
      breadcrumb_3: "Business transfer advertisment",
      title_1: "Owner/Agent Announcement",
      // title_2: "We issue the license to you through us.",
      // title_3: "Ahmed Al-Muhaisni Real Estate Group",
      owner_Agent_P: "A reliable advertisement for your property increases buyer confidence.",
      title_4: "Licensed Broker Advertisement",
      // title_5: "For real estate in the Kingdom of Saudi Arabia",
      // title_6: "Advertising license is required from the General Authority.",
      brokers_P: "Professional management of advertisements for licensed brokers.",
      title_7: "Contract documentation",
      title_8: "Instant documentation that protects rights without complications.",
      title_9: "Add an Ad",
      title_10: "Owner's ID Number",
      title_11: "Owner's Date Of Birth",
      title_12: "Receipt Number",
      title_13: "Owner's Mobile number",
      agencyPhoto: "Agency photo",
      receiptImage: "Receipt Image",
      title_15: "Receipt Date",
      title_16: "Next",
      title_17: "Owner",
      title_18: "Agent",
      title_19: "Agent ID Number",
      title_20: "Agent's Date Of Birth",
      title_21: "Agency Number",
      title_22: "Agency Date",
      title_23: "Agent's Mobile Number",
      title_24: "Add a licensed broker ad",
      title_25: "Val license number",
      title_26: "Advertisement license number",
      title_27: "Enter your Val license number",
      title_28: "Enter receipt number",
      title_29: "Enter the license number",
      title_30: "Enter the owner's mobile number",
      title_31: "Enter the agent's ID number",
      title_32: "Enter agency number",
      title_33: "Enter the agent's mobile number",
      title_34: "Next",
      title_35: "Property Documentation",
      title_36: "Full Name",
      title_37: "Mobile Number",
      title_38: "Next",
      title_39: "Enter full name",
      title_40: "Enter mobile number",

      title_41: "Add Property Data",
      title_42: "Property classification",
      title_43: "Commercial",
      title_44: "Residential",
      title_45: "Purpose of the advertisement",
      title_46: "For Sale",
      title_47: "For Rent",
      title_48: "For Investment",
      title_49: "Property type",
      title_50: "Type of resident",
      title_51: "Families",
      title_52: "singles",
      title_53: "Property description",
      title_54: "Detailed property description",
      title_55: "Price",
      title_56: "Property photos",
      title_57: "Area",
      title_58: "City",
      title_59: "Neighborhood",
      title_60: "Street",
      title_61: "Property number",
      title_62: "Floor number",
      title_63: "Floors Count",
      title_64: "Apartment Number",
      title_65: "Property Age",
      title_66: "Property Area 2 m",
      title_67: "Rooms Count",
      title_68: "Bathrooms Count",
      title_69: "The Site",
      title_70: "Longitude",
      title_71: "Latitude",
      title_72: "Add Property Features",
      title_73: "Next",
      title_74: "Ad Details",
      title_75: "Advertisement duration",
      title_76: "Classified As Featured Ad",
      title_77: "submit",
      title_78: "Save features",
      title_79: "agricultural",
      title_80: "Property documentation",
      title_81: "Commercial Project Release Announcement",
      title_82: "A formal transfer of ownership with a notarized transfer of ownership... higher selling opportunities.",
      title_83: "Professional property photography",
      title_84: "Professional photos will help you sell your property faster.",
      title_85: "Select the type of resident",
      title_86: "Owner/Agent Announcement",
      businessTransfer_P1: "We will find you the right, serious customer as soon as possible!",
      businessTransfer_P2: "Let us market your shop in the most effective ways.",
      businessTransfer_P3: "We connect your property with the largest real estate brokers and present it to clients.",
      businessTransfer_P4: "Serious people, to ensure you get the best deal as quickly as possible.",
      businessTransfer_button: "Business transfer request",
      businessTransfer_h6: "1. Basic Information",
      businessTransfer_name: "Name",
      name_placeholder: "Enter name",
      businessTransfer_mobile: "Contact mobile number",
      mobile_placeholder: "Enter phone number",
      businessTransfer_email: "Email address (optional)",
      email_placeholder: "Enter your email address",
      activity_Details: "2. Activity Details",
      business_Activity: "Type of business activity",
      chooseType_Business: "Choose the type of business activity",
      Project_Area: "Project area 2m",
      area_placeholder: "Enter the project area",
      description: "description of the activity",
      workersCount: "Workers count",
      workers_placeholder: "Enter workers count",
      annual_Rental: "Annual rental value",
      annual_placeholder: "Enter the value",
      Remaining: "Remaining lease term",
      Remaining_placeholder: "Select the duration",
      amount: "The required amount",
      amount_placeholder: "Enter the required amount",
      transfer_Reason: "transfer Reason",
      reason_placeholder: "choose Reason",
      location: "3. Project location",
      area: "Area",
      A_placeholder: "Enter the area",
      city: "City",
      city_placeholder: "Enter the city",
      neighborhood: "Neighborhood",
      neighborhood_placeholder: "Enter the neighborhood",
      location_Map: "Location on the map",
      view: "View",
      view_placeholder: "Select view",
      assets: "4. Assets and assets",
      assetsLabel: "Write us a list of assets within your project (equipment – ​​devices – furniture – decor – operating license...)",
      asset_placeholder: "Enter the menu",
      fixed_Asset: "Fixed asset condition",
      fixed_Asset_holder: "Select the fixed asset status",
      financial_Obigations: "Are there any financial obligations or debts?",
      no: "no",
      yes: "yes",
      projects_Strengths: "5. List the project's strengths.",
      projects_Weaknesses: "6. List the project's weaknesses.",
      Explain: "Explain the details",
      additional_Notes: "7. Additional Notes",
      project_Age: "Project age",
      project_Age_holder: "Enter the project's age",
      officesCount: "Offices count",
      officesCount_holder: "Enter offices count",
      roomsCount: "Rooms count",
      roomsCount_holder: "Enter rooms count",
      hallsCount: "Halls count",
      hallsCount_holder: "Enter halls count",
      doorsCount: "Doors count",
      doorsCount_holder: "Enter doors count",
      bathroomsCount: " Bathrooms count",
      bathroomsCount_holder: "Enter bathrooms count",
      floorsCount: "floors count",
      floorsCount_holder: "Enter floors count",
      parkingCount: "Parking count",
      parkingCount_holder: "Enter parking count",
      notices: "Notices",
      notices_holder: "Explain your observations",
      uploadMedia: "Upload image" ,
      button_Cancel: "Cancel and Restore",
      button_submit_request: "Submit request",
      free: "Publish it for free and sell it without effort.",
      Disclaimer: "Disclaimer",
      service: "The service is currently free.",
      service_2: "It will soon become a paid service!",
      meterPrice: "Meter Price",
      businessNameRequired: "The business name must be entered.",
      businessName: "Business name",
      brokerNumber: "Broker's mobile number",
      enterBrokerNumber: "Enter the broker's mobile number",
      TypeAdvertisement: "Type of advertisement",
      plot_Number: "Plot number",
      choose_Property_Age: "Choose the property's age",
      numberHalls: "Number of halls",
      furnished: "Furnished",
      yes: "Yes",
      no: "No",
      saudiBuildingCode: "Compliant with the Saudi building code?",
      propertyObligation: "Is there a tram stop near the property?",
      front: "Fronts list",
      chooseInterface: "Choose the interface",
      choose_type_Ad: "Choose the type of ad",
      FeaturedAd: "Featured ad, much faster spread",
      real: "Real",
      regular_Ad: "Regular ad - free for a limited time",
      regular: "Regular advertisement at a price",
      idType: 'Advertiser ID type',
      idTypeSelect: 'Select ID type',
      idTypePersonal: 'ID number',
      idTypeCompany: 'Unified establishment number',
      advertiserId: 'Advertiser ID number',
      allDataRequered: 'All data is required',
      ownerOrBroker: "Owner Advertisement / Licensed Broker",
      sellingBusiness: "Selling your business starts with a free advertisement.",
      advertisingLicense: "Issuing an advertising license",
      submitRequest: "Submit a new advertising license application.",
      applicationAdvertisingLicense: "Application for an advertising license",
      landRegistry_number: "Deed number, property number, or land registry number",
      deedNumber: "Enter the deed number or property number",
      owner_Agent: "Owner/Agent ID Number",
      residencyNumber: "Enter your national ID or residency number",
      dateBirth: "Owner/Agent's Date of Birth",
      datePlaceholder: "day / month / year",
      Owner_Agent_MobileNumber: "Owner/Agent's Mobile Number",
      placeholdermobileNumber: "05xxxxxxxx",
      price: "Price",
      propertyValue: "Enter the property value",
      typeAdvertisement: "Type of advertisement",
      sale: "Sale",
      rent: "Rent",
      attachCopy: "Attach a copy of the instrument",
      certifiedDocument: "Click here to attach a copy of the certified document",
      supported_Fileformats: "Supported file formats: PDF, JPG, PNG (maximum 5 MB)",
      encounteredProblem: "Do you have a question or have you encountered a problem?",
      contactUs: "Contact us",
      paymentSubmission: "Payment and order submission",
    },

    property: {
      breadcrumb_1: "Home",
      breadcrumb_2: "Properties",
      title_1: "Property Management Request",
      title_2: "Do you have a property for rent or sale?",
      title_3: "Your property deserves to be listed here!",
      title_4: "Property Management Request",
      title_5: "Our advantages in property management!",
      title_6: "Maintenance",
      title_7: "Plumbing, electricity, cleaning work and elevator maintenance",
      title_8: "Marketing and Leasing",
      title_9: "In-app display, social media platforms and advertising campaigns",
      title_10: "the accounts",
      title_11: "Collecting rent payments on time",
      title_12: "Periodic property evaluation",
      title_13: "Periodic rental rates are updated according to market prices.",
      title_14: "Legal and tax services",
      title_15: "We follow up on all legal and tax real estate matters.",
      title_16: "Competitive management ratio",
      title_17: "Only 5% of the collection rate!",
      property_title_1: "Do you have a property for rent or for sale?",
      propertyRentSale: "Do you have a property for rent or sale ?",
      propertyDeserves: "Your property deserves to be showcased here.",
      property_title_3: "Property management services include:",
      service_include_1: "Routine maintenance (plumbing - electricity - elevators - cleaning) with follow-up on reports",
      service_include_2: "Appointing a property supervisor to follow up with tenants and receive maintenance requests",
      service_include_3: "Review by relevant government agencies (Municipality - Electricity - Water)",
      service_include_4: "Marketing and leasing accounts, sponsored campaigns, and billboards.",
      service_include_5: "Managing the property owner's tax file",
      service_include_6: "Contract management and documentation on the Ejar platform",
      service_include_7: "Accounts (collecting rent payments on the specified dates through the accounts department)",
      service_include_8: "Rental prices are updated periodically according to market trends.",
      service_include_9: "Maintaining the confidentiality of landlord and tenant information",
      service_include_10: "Submitting electronic reports via the website's control panel",
      service_include_11: "A specialized legal committee will follow up on cases of defaulting tenants, with the possibility of fees being paid by the Ahmed Al-Muhaisni Real Estate Group according to the agreement.",
      btn_contactCustomer: "Contact customer service",
      vacancy: "Vacancy",
      Landlord: "Landlord",
      Sold: "Sold",
      rentalDetails: "Rental details",
      rentalValue: "rental value",
      allProperties: "All properties",
      propertyDetails: "Property details",
      viewDocuments: "View documents",
      amountsCollected: "amounts collected",
      amountsDue: "Amounts due",
      overdueAmounts: "Overdue amounts",
      contactManager: "Contact your account manager",
      owner_controlPanel: "Owner's control panel",
    },

    profile: {
      breadcrumb_1: "Home",
      breadcrumb_2: "Account Details",
      fullName: "Full Name",
      email: "Email",
      Absher_mobile: "Absher_mobile",
      Save_Changes: 'Save Changes',
      accountDetails: "My account details",
      changePassword: "Change password",
      distinguishedOwner: "distinguished owner",
      activeAds: 'Active ads',
      underReview: 'under review',
      falLicenseNum: 'FAL License Num',
      aqaryLine1: 'Real estate',
      aqaryLine2: 'featured',
      priceLine1: 'committed',
      priceLine2: 'fees',
      since: 'since',
      lastSeen: 'last seen',
      profileMenu: 'Profile',
      about: 'About',
      currentAccount: "Current account type",
      changeAccount_Type: "Change account type",
      accountType: "Account Type",
      accountDetails: "Account Details",
      accountVerification: "Account Verification",
      accountType_suitable: "Please select the account type suitable for your real estate activity.",
      RealEstate_Entity: "Real estate entity",
      licensed_RealEstate: "Account for licensed real estate companies and establishments.",
      realEstate_Broker: "Real Estate Broker",
      licensed_RealEstate_brokers: "An account for licensed real estate brokers actively engaged in real estate business.",
      personal: "Personal",
      personalAccount: "A personal account for individuals to search for and view properties.",
      importantInformation: "Important Information",
      detailsReviewed: "Your details will be reviewed by the management team within 1–3 business days before the new account type is activated, allowing you to take full advantage of the platform's features.",
      back: "Back",
      next: 'Next',
      realEstate_EntityDetails: "Real Estate Entity Details",
      requiredFields: "Please fill in the required fields and upload the certified official documents.",
      establishmentDetails: "Establishment Details",
      commercialRegistration: "Commercial Registration Number",
      enter_Commercialregistration: "Enter the commercial registration number.",
      fALLicense_Number: "FAL License Number",
      enterFallicenseNumber: "Enter the license number.",
      expirationDate: "Expiration Date",
      licenseExpiration_Date: "Enter the license expiration date.",
      uploadingRequiredDocuments: "Uploading the required documents",
      FalLicense: "Fal License",
      clickUploadFile: "Click to upload the file.",
      pleaseEnsure: "Please ensure the documents are clear and valid before uploading them. Files must be in PDF format or clear images.",
      licenseIssued: "A copy of the FAL license issued by the General Real Estate Authority.",
      fileMustbe: "The file must be in PDF format or a clear, legible image not exceeding 5 MB.",
      submitRequest: "Submit Request",
      realEstateBrokerDetails: "Real Estate Broker Details",
      basicLicense_Information: "Basic License Information",
      commercialRegistrationissued: "A copy of the commercial registration issued by the Ministry of Commerce.",
      pleaseAttach: "Please attach a clear, up-to-date, and valid copy of the commercial registration.",
      commercialRegistrat_image: "commercial Registrat image",
      dataSent: "Your data has been sent.",
      successfullySubmitted: "Your request has been successfully submitted! It will be reviewed by the team within 1–3 business days. Thank you.",
      myAccount: "Return to my account",
      homePage: "Go to the home page",
      establishment: "Name of the Establishment",
      aboutLicensee: "About the Licensee",
      serviceNumber: "Unified Customer Service Number",
      companyLogo: "Company logo",
      companyLogoAttach: "Please attach a clear copy of the company logo.",
      enterEstablishment: "Enter the name of the establishment",
      changeyour_Account: "Do you want to change your account type?",
      alert: "alert",
    },

    myrequests: {
      breadcrumb_1: "Home",
      breadcrumb_2: "My Requests",
      Property_management: "Property Management",
      Contract_Documentation: "Contract Documentation",
      RealEstate_Financing: "RealEstate Financing",
      RealEstate_Requests: 'RealEstate Requests',
      orderNumber: "Order Number",
      families: "families",
      single: "Single",
      title_1: "You haven't made any requests yet!",
      title_2: "If you need any request, do not hesitate, order it immediately",
      title_3: "Applicant:",
      title_4: "phone number :",
      title_5: "Amount :",
      allRequests: "All",
      legal: "Legal advice",
      photographyRequests: "Professional photography requests",
      transferRequests: "Transfer requests",
      advertisingLicense: "Advertising license",
      identityNumber: "Identity Number",
    },

    myproperty: {
      breadcrumb_1: "Home",
      breadcrumb_2: "Purchase orders",
      Collected: 'Collected',
      more: 'Learn more',
      title_1: "There are no purchase requests added yet!",
      title_2: "Do you want to buy a property? All added purchase requests will appear here.",
      title_3: "Buying a property",
    },

    myreservations: {
      breadcrumb_1: "Home",
      breadcrumb_2: "My Reservations",
      title_1: 'You have not booked any Property.',
      title_2: ' Dont let it bother you and start buying the house of your life!',
      button: 'Browse Our Properties',
    },

    myrents: {
      breadcrumb_1: "Home",
      breadcrumb_2: "My Rents",
      Maintenance_request: 'Maintenance Request',
    },

    previewlist: {
      breadcrumb_1: "Home",
      breadcrumb_2: "Previews",
      title_1: 'You have not booked any Previews.',
      title_2: 'Dont let it bother you and start buying the house of your life!',
      button: 'Browse Our Properties',
      Previous: 'Previous',
      Next: 'Next',
    },

    advertisements: {
      breadcrumb_1: "Home",
      breadcrumb_2: "My Ads",
      title_1: 'Advertising management',
      title_2: 'No ads added yet!',
      title_3: 'No ads have been added. Add an ad for your property now.',
      title_4: 'Follow him through the page',
      button: 'Add a new ad',
      edit: 'Edit',
      delete: 'Delete',
      endDate: 'Advertising license expiry date',
      detailsLink: 'View details on the General Authority for Real Estate',
      fal: 'Fal license number',
      region: 'region',
      city: 'city',
      neighborhood: 'neighborhood',
      propertyType: 'property type',
      planNumber: 'plan number',
      landNumber: 'land number',
      numberOfRooms: 'number of rooms',
      propertyArea: 'area',
      streetWidth: 'street width',
      propertyFace: 'property interface',
      propertyUsages: 'property usages',
      guaranteesAndTheirDuration: 'Guarantees and their duration',
      propertyUtilities: 'property services',
      locationDescriptionOnMOJDeed: 'Property location description according to the deed',
      obligationsOnTheProperty: 'Other obligations on the property',
    },

    propertyrequest: {
      breadcrumb_1: "Home",
      breadcrumb_2: "Property Request",
      title_1: 'Area',
      title_2: 'City',
      title_3: 'Neighborhood',
      title_4: 'Property Type',
      title_5: 'Purpose',
      title_6: 'For Sale',
      title_7: 'For Rent',
      title_8: 'Asking Price',
      title_9: 'Lowest Price',
      title_10: 'Highest Price',
      title_11: 'type of housing',
      title_12: 'single',
      title_13: 'Families',
      title_14: 'Rooms Count',
      title_15: 'Floor Number',
      title_16: 'Property Age',
      title_17: 'Add Property Features',
      title_18: 'Property Request',
      title_19: 'The property request has been added successfully.',
      title_20: 'We will contact you soon to present options that will please you.',
      title_21: 'God willing',
      title_22: 'Browse Other Properties',
      title_23: 'Select the region',
      title_24: 'Choose the city name',
      title_25: 'Choose the neighborhood name',
      title_26: 'Select property type',
      title_27: 'Save features',
      title_28: 'Enter the property duration in years',
      newTitle: "We will contact you soon to present the most suitable options for you.",
      area: "Area",
      details: "Details",
      explain_Details: "Explain the details",
    },

    favoriteProperties: {
      breadcrumb_1: "Home",
      breadcrumb_2: "Favorite Properties",
      title_1: "You have no favorite properties.",
      title_2: "Really? Browse our properties and we are sure you will be amazed.",
      title_3: "Browse Our Properties",
    },

    maintenances: {
      breadcrumb_1: "Home",
      breadcrumb_2: "Maintenances",
      breadcrumb_3: "New maintenance request",
      title_1: "Within 24 hours, the price",
      price: "riyals",
      title_2: "Quick maintenance request!",
      title_3: "Within 120 minutes, the price",
      title_4: "Maintenance of the houses of God",
      title_5: "By requesting this service, you contribute to the reward of caring for the mosques of God.",
      title_6: "Problem title",
      title_7: "Type of problem",
      title_8: "Choose the type of problem",
      title_9: "Discount code",
      title_10: "Application",
      title_11: "Description of the problem",
      title_12: "Attach photos of the problem",
      title_13: "the Site",
      title_14: "Longitude",
      title_15: "latitude",
      title_16: "Maintenance Request",
      title_17: "Maintenance request has been successfully completed.",
      title_18: "A technician will be assigned to your problem and will arrive as soon as possible to solve the problem with ease.",
      title_19: "Back to Maintenance",
      title_20: "Activation successful",
      title_21: "Continue",
      title_22: "Riyal",
      title_23: "",
      title_24: "",
      looking_provider: 'We are currently searching for the right service provider for your needs',
      order_number: 'order number',
      service_name: 'Required service',
      title: 'Issue description',
      description: 'Issue details',
      image: 'Issue image',
      chat: 'Chat',
      order_received: 'We have received your maintenance request',
      manaule_assign: 'The service provider will be assigned by customer service and will contact you as soon as possible.',
      phoneNumber: "phone Number",
      orderDetails: "Order details",
      seriousnessPrice: "Seriousness price",
      amountPaid: "Amount paid",
      orderStatus: "Order status",
      technician: "Looking for a technician",
      confirmed: "Your request has been confirmed and we are currently searching for the best technician in",
      area: "Your area!",
      technicalInformation: "Technical Information",
      help: "Help",
      hasOrder: "You have a maintenance order",
      serviceCost: "Service cost",
      totalAmount: "Total amount",
      scheduleMaintenance: "Do you want to schedule maintenance in the future?",
      locationRequired: "The location must be specified on the map.",
    },

    maintenanceslist: {
      breadcrumb_1: "Home",
      breadcrumb_2: "Maintenance",
      breadcrumb_3: "Maintenance log",
      title_1: "Add a new maintenance request",
      title_2: "You have not requested any maintenance yet.",
      title_3: "If you need any maintenance on your property, request it immediately!",
      title_4: "Currrent Maintenance",
      title_5: "Completed Maintenance",
      title_6: "Order Number",
      maintenanceRequest: "Maintenance request",
      serviceRating: "Service Rating",
      orderDetails: "Order Details",
      re_Order: "Re-order",
    },

    maintenanceDetails: {
      breadcrumb_1: "Home",
      breadcrumb_2: "Maintenance",
      breadcrumb_3: "Order details",
      title_1: "The problem has been solved.",
      title_2: "The technician arrived and started working on the problem.",
      title_3: "A technician has been assigned to the problem described.",
      title_4: "New maintenance has been requested.",
      title_5: "Payment",
      title_6: "Cancel Maintenance Request",
      title_7: "Riyal",
      title_8: "Reasons for canceling a maintenance request",
      title_9: "Choose the reason for canceling the order",
      technician: "The responsible technician",
      providerNotes: "provider Notes",
      imageBefore: "Image before maintenance",
      imageAfter: "Image after maintenance",
      evaluateExperience: "Evaluate your experience",
      customerRate: "customer Rate",
      maintenanceCost: "Maintenance cost",
      onlyRiyal: "Only riyal,nothing else",
      tip: "Add a tip",
      optionalTip: "Pay an optional tip to the technician",
      paymentSuccessful: "Payment successful",
      honorServe: "It was our pleasure to serve you, and we pray that your home will always be filled with your presence.",
      backMaintenance: "Back to maintenance",
      successfullyEvaluated: "Your experience has been successfully evaluated.",
      maintenanceService: "How was the maintenance service?",
      feedback: "Your feedback is important to us",
      btnConfrim: "Confirm",
      theTechnician: "The technician is on his way to you.",
      request_ChangeProvider: "Request to change provider",
      ProblemTechnician: "Do you have a problem with the technician?",
      avoidProblem: "We apologize for our mistake. Please share the reason for the cancellation so we can avoid this problem next time!",
      successfullyResolved: "The problem has been successfully resolved.",
      laborCost: "Labor cost",
      serviceCost: "Service cost",
      spareParts: "Cost of spare parts",
      totalAmount: "Total amount",
      serviceRequest: "Service request:",
      doneTime: "Termination of service:",
      orderScheduled: "Your order is scheduled for date",
      maintenanceAppointment: "Maintenance appointment",
      demand: "demand",
      future: "future",
      cancelOrder: "Cancel order :",
      opinionMatters: "Your opinion matters to us. We'd like to know why the order was cancelled so we can improve your experience in the future. 🙏",
      successfullyCancelled: "The order was successfully cancelled.",
      reasonCancellation: "Thank you for sharing the reason for the cancellation, and we look forward to serving you again in the future!",
      maintenanceRequest: "New maintenance request",

    },

    wallet: {
      breadcrumb_1: "Home",
      breadcrumb_2: "Wallet",
      title_1: 'Current Balance',
      title_2: 'Latest Transactions',
      title_3: 'All',
      title_4: 'Add Balance',
      title_5: 'Real Estate Reservation',
      title_6: 'Book a luxury preview',
      title_7: 'Maintenance request',
      title_8: 'No transactions yet!',
      title_9: 'Use your wallet easily in all transactions',
      title_10: 'Charge Wallet Now',
      title_11: 'Amount to be added',
      title_12: 'Payment Method',
      title_13: 'Choose a payment method',
      title_14: 'Bank Card',
      title_15: 'Payment',
      title_16: 'Wallet',
      message: "Please enter the required amount",
      FeaturedAd: "Featured Ad",
      rentPayment: "Rent Payment",
      bankCard: "Payment via bank card or Apple Pay",
      appWallet: "Via your in-app wallet",
      cost: "Cost",
      choosePayment_Method: "Please choose the appropriate payment method.",
      payment: "Payment",
    },

    financialTransactions: {
      breadcrumb_1: 'Home',
      breadcrumb_2: 'Financial Transactions',
      title_1: 'You have not made any financial transactions yet.',
      title_2: 'All transactions are shown here so you can keep track of everything.',
    },

    backAccount: {
      breadcrumb_1: 'Home',
      breadcrumb_2: 'Bank Account',
      title_1: "Account Number",
      title_2: "Bank Name",
      title_3: "Account Holder Name",
      title_4: "Save Changes",
    },

    blog:{
      breadcrumb_1: 'Home',
      breadcrumb_2: 'Blog',
    },

    Settings:{
      breadcrumb_1: 'Home',
      breadcrumb_2: 'Settings',
      title_1: 'Change Password',
    },

    questions:{
      breadcrumb_1: 'Home',
      breadcrumb_2: 'Frequently Asked Questions',
    },

    citiesList:{
      breadcrumb_1: 'Home',
      breadcrumb_2: 'Cities of the region',
      search: "Search for city",
      notFound: "There are no cities available for this region yet!",
    },

    propertielist:{
      breadcrumb_1: 'Home',
      breadcrumb_2: 'Search',
      title_1: 'Search results',
      title_2: 'Area',
      title_3: 'Select the region',
      title_4: 'Cities',
      title_5: 'Choose the city name',
      title_6: 'neighborhood',
      title_7: 'Choose the neighborhood name',
      title_8: 'Property type',
      title_9: 'Select property type',
      purpose: 'Purpose',
      title_11: 'For sale',
      title_12: 'For rent',
      title_13: 'Rental price budget',
      title_14: 'Lowest price',
      title_15: 'Highest price',
      title_16: 'Resident type',
      title_17: 'single',
      title_18: 'Families',
      title_19: 'Number of rooms',
      title_20: 'Floor number',
      title_21: 'Property age',
      title_22: 'Search for results',
      title_23: 'Delete search',
      title_24: 'There are no search results currently!',
      area: "Area ",
      price: "Price",
      from: "From",
      to: "To",
    },

    propertydetails: {
      breadcrumb_1: 'Home',
      breadcrumb_2: 'Property Details',
      title_1: 'Available for sale',
      title_2: 'Property features',
      title_3: 'Property description',
      title_4: 'Street',
      title_5: 'Building number',
      title_6: 'Apartment number',
      title_7: 'Number of floors',
      title_8: 'Floor number',
      AdvertiserInformation: 'Advertiser Information',
      title_10: 'Real Estate Agent',
      title_11: 'Reserve the property until purchase',
      title_12: 'Book an appointment',
      title_13: 'Real Estate Financing',
      title_14: 'the Site',
      title_15: 'You must be logged in.',
      title_16: 'To book an appointment, you must log in to',
      title_17: 'Your account / Create a new account via Nafath',
      title_18: 'Login',
      title_19: 'Create a new account by',
      title_20: 'Nafath',
      // title_21: 'Paying the property reservation fee means agreeing to the right',
      // title_22: 'Withdrawal from the contract without refund of the reservation amount',
      title_23: 'If it is not executed within 3 days of payment, it will be considered',
      // title_24: 'Final withdrawal, reservation amount is non-refundable',
      title_25: 'Available for rent',
      title_26: 'Available for investment',
      ownerName: "Owner of this property",
      reportAd: "Report this ad",
      renter: "Property renter",
      renterName: "renter",
      lawyer: "Lawyer",
      contact: "Contact",
      customers: "Customers",
      contactService: "Contact service",
      financing: "Do you need financing that",
      financingHelps: "Applying for financing helps you pay your rent easily and conveniently, allowing you to focus on other things.",
      financialObligations: "Your life without worrying about your financial obligations",
      requestFinancing: "Request financing now",
      propertyDocuments: "Property documents",
      deedNumber: "Deed number",
      identityImage: "Identity image",
      Viewimage: "View image",
      buildingLicence: "Building licence",
      viewLicence: "View licence",
      civilDefense: "Civil defense certificate",
      viewcertificate: "View certificate",
      newMaintenance: "New maintenance request",
      more: "More",
      showLess: "Show less",
      licenseNumber: "Advertising license number",
      propertyAge: "propertyAge",
      propertyType: "propertyType",

    },

    previewdetails: {
      breadcrumb_1: 'Home',
      breadcrumb_2: 'Previews',
      breadcrumb_3: 'Next Preview',
      title_1: 'The property required for inspection',
      title_2: 'Our agent for this property',
      title_3: 'Real Estate Agent',
      title_4: 'Payment of the inspection fee',
      title_5: 'the Site',
      title_6: 'Are you sure you want to cancel the preview?',
      title_7: 'Are you sure you dont want to view this property? Thats okay.',
      title_8: 'You can find more great properties with us.',
      title_9: 'I want to view this property',
      title_10: 'Cancel Preview',
      title_11: 'Preview successfully cancelled',
      title_12: 'Browse more of our amazing properties to find your perfect property.',
      title_13: 'Browse other properties',
      confirmMsg: "The inspection booking has been successfully paid for.",
      ownerName: "Owner of this property",
      btn_backHome: "Back to Home",
    },

    propertymanagement: {
      breadcrumb_1: 'Home',
      breadcrumb_2: 'Property management',
      title_1: 'Add a property management request',
      title_2: 'Full name',
      title_3: 'Contact number',
      title_4: 'The Area',
      title_5: 'The City',
      propertyDescription: 'Property description',
      title_7: 'Submit an application',
      title_8: 'Data uploaded successfully',
      // title_9: 'We are honored to communicate with you through the Property Management Department',
      // title_10: 'To provide you with a unique experience',
      title_11: 'Back to Home',
      title_12: 'This field is required',
      paragraph: "We will contact you soon through the property management department to provide you with excellent service.",
      receiptNumber: "receipt Number",
    },

    propertypreview: {
      breadcrumb_1: 'Home',
      breadcrumb_2: 'Property Details',
      breadcrumb_3: 'Book a property inspection appointment',
      title_1: 'Working hours',
      title_2: 'Choose the time',
      title_3: 'Book your luxury preview now!',
      title_4: 'A luxury car and a private driver will come and take you to the property and take you to your home after the inspection, with a private marketer waiting.',
      title_5: 'Book a quick consultation',
      title_6: 'Book a luxury preview',
      title_7: "Your preview has been successfully booked! We'll be waiting for you!",
      title_8: 'Preview details',
      title_9: 'Real estate agent number',
      title_10: 'Back to Home',
      price: "500",
      only: "only",
      address: "Address",
      paymentSuccessfully: "Payment successfully confirmed. Thank you for your trust.",
      paymentProcess:  "The payment has been successfully processed, and receipt of the required amount has been confirmed. Thank you for your trust; we look forward to serving you.",
      btn_backHome: "Go to Home",
      location: "Please specify your location",
      normal_preview: 'Quick preview',
      fancy_preview: 'Luxury preview',
      preview_location: 'preview location',
    },

    propertyreservation: {
      breadcrumb_1: 'Home',
      breadcrumb_2: 'Property Details',
      breadcrumb_3: 'Reserve the property until purchase',
      stepsCompleteRental: "Steps to Complete the Rental",
      propertyReservation: 'Property Reservation',
      confirmsyour_Serious: "This confirms your serious intent and signals us to begin preparing the contracts; the reservation fee is deducted from the total rent.",
      contractsSent: "Contracts Sent via the Ejar Platform",
      afterReservation: "After the reservation, we prepare the contracts and submit them to the Ejar platform; you will receive a notification once they are ready.",
      payRent: "Pay the Rent and Move In Immediately",
      verifyContracts: "Verify the contracts on the Ejar platform, complete the transaction via our app, and move in right away.",

      title_12: 'Book the property at',
      title_13: 'Riyals',
      title_14: "Can I get a refund for the reservation?",
      title_15: "Paying the property reservation fee means agreeing to the right to withdraw from the contract without a refund.",
      title_16: "If the payment is not made within 3 days of the order being made, it will be considered a final cancellation and the reservation amount will not be refunded.",
      successfullyBooked: "The property has been successfully booked!",
      contractswithin: "We will prepare the contracts within 48 hours.",
      realEstate_Exchange: "Coming via the real estate exchange",
      notificationSoon: "We will send you a notification as soon as it is finished.",
      btn_backHome: "Back to Home",
      verifyValidity: "Verify the validity of the contracts on the Real Estate Exchange app and complete the sale within the app.",
      ownershipOfficially: "The ownership is officially transferred to your name.",
    },

    blogDetails: {
      breadcrumb_1: 'Home',
      breadcrumb_2: 'Blog',
      breadcrumb_3: 'Blog Details',
    },

    changePassword: {
      breadcrumb_1: 'Home',
      breadcrumb_2: 'Settings',
      title_1: 'Change password',
      title_2: 'Old Password',
      title_3: 'New Password',
      title_4: 'Send',
      confirmMessage: "The password has been successfully changed",
    },

    forgetPassword: {
      title_1: 'Forgot your password',
      title_2: 'Your mobile number',
      title_3: 'Enter your mobile number',
      title_4: 'Enter the code sent',
      title_5: 'New Password',
    },

    propertieupdate: {
      breadcrumb_1: '',
      breadcrumb_2: '',
      breadcrumb_3: '',
      title_1: 'Owner type',
      title_2: 'Owner',
      title_3: 'Agent',
      title_4: 'Real Estate broker',
      title_5: 'Add an ad',
      title_6: 'Receipt Images',
      title_7: 'Receipt Number',
      title_8: 'Receipt Date',
      title_9: 'Owner ID number',
      title_10: "Owner's date of birth",
      title_11: "Owner's mobile number",
      title_12: "Agent ID number",
      title_13: "Agency number",
      title_14: "Agency Date",
      title_15: "Agent's date of birth",
      title_16: "Agent's mobile number",
      title_17: "Add a licensed broker ad",
      title_18: "Val license number",
      title_19: "Advertisement license number",

      title_20: "Property documentation",
      title_21: "Full name",
      title_22: "Mobile number",
      title_23: "Enter full name",
      title_24: "Enter mobile number",

      title_25: "Add property data",
      title_26: "Property classification",
      title_27: "commercial",
      title_28: "residential",
      title_29: "Purpose of the advertisement",
      title_30: "For Sale",
      title_31: "For Rent",
      title_32: "For Investment",
      title_33: "Property type",
      title_34: "Type of resident",
      title_35: "Families",
      title_36: "Singles",
      title_37: "Property description",
      title_38: "Detailed property description",
      title_39: "Price",
      title_40: "Property photos",
      title_41: "The Area",
      title_42: "The City",
      title_43: "The Neighborhood",
      title_44: "The Street",
      title_45: "Property number",
      title_46: "Floor number",
      title_47: "Number of floors",
      title_48: "Apartment number",
      title_49: "Property age",
      title_50: "Property area",
      title_51: "Number of rooms",
      title_52: "Number of bathrooms",
      title_53: "the Site",
      title_54: "Longitude",
      title_55: "latitude",
      title_56: "Add property features",
      title_57: "Ad Details",
      title_58: "The ad is classified as a featured ad.",
      title_59: "Send",
      title_60: "Save features",
      agencyPhoto: 'Agency Images',
      
    },

    terms: {
      breadcrumb_1: 'Home',
      breadcrumb_2: 'Terms and Conditions',
      title_1: 'Terms and Conditions Agreement',
      title_2: 'This agreement is dated 09/01/2026 AD',
      title_3: 'Introduction',
      introduction: "Your access to and use of the Ahmed Al-Muhaisni Real Estate website or application is subject to these terms and conditions and the laws of the Kingdom of Saudi Arabia. Your access to and use of these sites constitutes your unconditional acceptance of these terms and conditions and the Privacy Policy, whether you are a registered user or not. You acknowledge and warrant your legal capacity to enter into this agreement in accordance with all the terms and conditions contained herein. This agreement shall be effective from the date of your first use of the Ahmed Al-Muhaisni Real Estate website or application.",
      introduction_1: "The Terms and Conditions Agreement published on the Ahmed Al-Muhaisni Real Estate website or application was put in place to protect and preserve the rights of both the Ahmed Al-Muhaisni Real Estate website or application and the users who benefit from the services of the Ahmed Al-Muhaisni Real Estate website or application, with or without registration.",
      definitions: "Ahmed Al-Muhaisni Real Estate Company is a company registered in the Kingdom of Saudi Arabia and headquartered in Riyadh, Saudi Arabia. It manages and operates the services, whether the website or the application of Ahmed Al-Muhaisni Real Estate Company.",
      definitions_1: "Ahmed Al-Muhaysini Real Estate Company offers marketing, real estate, tourism, and service provider services through its website and mobile application. These services include, but are not limited to, the Ahmed Al-Muhaysini Saudi Real Estate app for iOS, the Ahmed Al-Muhaysini Saudi Real Estate app for Android, and the Ahmed Al-Muhaysini Saudi Real Estate website: https://aqaralmuhaysini.com",
      definitions_2: "The website: Ahmed Al-Muhaysini Real Estate website available through the following link https://aqaralmuhaysini.com and all sites and pages that can be accessed through the aforementioned website or application. The term also includes computer applications and smartphone applications on Android or iOS platforms connected to it, and all services and features provided by Ahmed Al-Muhaysini Real Estate Company. Where the text indicates this, the term is used to refer to the operator.",
      definitions_3: "User: Any natural or legal person who uses the Ahmed Al-Muhaisni Real Estate website to benefit from the services provided through the website or application, whether registered or not, and they are collectively referred to in this agreement as (Users).",
      definitions_4: "Service providers: Those who provide services through the website or application. Ahmed Al-Muhaisni Real Estate connects service providers with users through the website or application, allowing users to search for and order the products they require from the service providers.",
      articleOne: "These terms and conditions are subject to the laws and regulations in force in the Kingdom of Saudi Arabia. If any of the provisions contained in this policy conflict with the laws and regulations in force in the Kingdom of Saudi Arabia, it shall not affect the rest of the provisions, and the rest of the terms and conditions shall be considered in force.",
      articleOne_1: "Ahmed Al-Muhaisni Real Estate Company strives to provide accurate and correct information as much as possible. However, errors may occur from time to time. The Ahmed Al-Muhaisni Real Estate website or application does not bear any responsibility for any error in the information contained on the Ahmed Al-Muhaisni Real Estate website or application, and does not grant any express or implied warranties, without exception, of non-infringement or validity relating to any matter. The Ahmed Al-Muhaisni Real Estate website or application does not bear any responsibility for the content available on any other website accessed through these electronic channels or from which access is made to the Ahmed Al-Muhaisni Real Estate website or application.",
      articleOne_2: "The Ahmed Al-Muhaisni Real Estate website or application makes efforts to ensure the quality of the published information and does not bear any responsibility towards third parties in the event of a breach of the terms and conditions. It has the right to suspend the service for damage resulting from the user, relying on primary sources. The Ahmed Al-Muhaisni Real Estate website or application is not responsible for illegal actions that may be carried out by service providers or users.",
      articleOne_3: "Advertising or displaying any goods or services, conducting or sending surveys or message threads, or uploading any file published by the user is contrary to the privacy policy and terms and conditions of the Ahmed Al-Muhaisni Real Estate website or application, and it should be noted that it is not legally permitted to promote it in these ways.",
      articleTwo: "When you use the Ahmed Al-Muhaisni Real Estate website or application, you acknowledge and agree to the following: You acknowledge and guarantee your legal capacity to enter into this agreement in accordance with all the terms and conditions contained therein, and to use the website or application in your personal capacity or on behalf of a person you have the right to represent on the Ahmed Al-Muhaisni Real Estate website or application, for example, but not limited to, through agency or employment only, and not to use the Ahmed Al-Muhaisni Real Estate website or application as any person you do not have the right to represent. The user understands all the legal consequences that result from providing entered information and materials that are wrong, incorrect, inaccurate, illegal, or incomplete during any use, and not to share any information that you do not have the right to publish or share.",
      articleTwo_1: "The user acknowledges that the Ahmed Al-Muhaisni Real Estate website or application bears no responsibility towards the user or any third party for any content published on the Ahmed Al-Muhaisni Real Estate website or application. The user bears any other consequences, including any damage or loss incurred by the Ahmed Al-Muhaisni Real Estate website or application or any third party as a result of any such breach. The Ahmed Al-Muhaisni Real Estate website or application has the right to take the necessary measures and seek recourse against the user in the event of any damage, whether direct or indirect, and to pay all fees due for the services of the Ahmed Al-Muhaisni Real Estate website or application when they are due, and provided that all governmental requirements and obligations apply to you and that you obtain all the required licenses to benefit from the services of the Ahmed Al-Muhaisni Real Estate website or application.",
      articleTwo_2: "You must not infringe upon the rights of any other user or service provider in any way within the Ahmed Al-Muhaisni Real Estate website or application, nor attempt to deceive, lie, or mislead in any way to harm any other user. You must not use any means, including but not limited to attempting to conceal your identity through VPN or proxy software, to violate the terms and conditions, bypass security measures, access unauthorized content, collect or obtain information or data pertaining to the website, application, or its users, or republish it without permission. You must not publish, distribute, or upload any defamatory, offensive, abusive, harmful, threatening, abusive, deceptive, racist, morally objectionable, or other illegal content or information. You must not publish any fictitious or speculative content or materials, or make false, inaccurate, misleading, deceptive, libelous, or defamatory comments. You must not engage in discussions about international politics or sovereignty, prominent figures, or any discussions unrelated to the services provided.",
      articleTwo_3: "Not to infringe on copyright, trademarks, patents, publicity, databases or other property or intellectual property rights, not to impersonate Ahmed Al-Muhaisni Real Estate Company or its representative or employee or any capacity that suggests that you are affiliated with it without official permission, and to prevent harm to Ahmed Al-Muhaisni Real Estate Company and compensate it for all liabilities, losses, claims and expenses, including legal fees and damages, whether direct or indirect, resulting from misuse, and to bear all legal and criminal responsibility resulting from any violation by the user or service provider.",
      articleThree: "Article Three: Service Provisions (Advertising)",
      articleThree_1: "When you publish any real estate advertisement on the Ahmed Al-Muhaisni Real Estate website or application, you acknowledge and commit to complying with all relevant regulations, laws, and legislation, obtaining all required licenses and permits for the property being advertised or for the service provider, ensuring the legal eligibility and right to publish the real estate advertisement, bearing the consequences of any violation thereof, ensuring the accuracy of all information in the advertisement and that it is correct, including but not limited to the section, classification, photos, price, services, description, location, and any other requirements or restrictions, undertaking to keep this information updated at all times and bearing the consequences of not updating it, and the inability to modify the type and location of the advertisement after its publication, interacting with and responding to user communications, and regarding commissions, paying the imposed advertisement commission upon completion of the real estate transaction in the event of exemption from fees.",
      articleFour: "Article Four: Provisions for the (Orders) Service",
      articleFour_1: "When you post any request on the Ahmed Al-Muhaisni Real Estate website or application, you acknowledge and commit to the seriousness of the request, the accuracy of the data entered in it, interaction with users who want to communicate and vice versa for the user after sending the request, not posting fake requests for any reason, and paying any fees imposed on posting the request.",
      articleFive: "Article Five: Provisions for the (Distinguished Customer) Service",
      articleFive_1: "By subscribing to the Ahmed Al-Muhaisni Real Estate website or application, you acknowledge and agree that your subscription will be renewed periodically according to the activation date. The user understands that service features are subject to increase or change whenever Ahmed Al-Muhaisni Real Estate deems it appropriate. Misuse of the service, including but not limited to targeting property owners for marketing purposes or clients in general, will result in service suspension without refund of subscription fees and without prior notice. The search results for Aqar Plus filters depend primarily on input from advertisers, and the Ahmed Al-Muhaisni Real Estate website or application provides no guarantees regarding the accuracy of the information entered.",
      articleSix: "Article Six: Provisions for the (Express Sales) Service",
      articleSix_1: "In this article, the following definitions are used: Quick Sale is a service provided on the Ahmed Al-Muhaisni Real Estate website or application. It serves the advertiser who wishes to offer their services to those seeking the service. The Ahmed Al-Muhaisni Real Estate website or application receives offers from potential buyers. The advertiser is the owner of the right to dispose of the offered service, or their representative, or the licensed real estate broker in the case of real estate, who is authorized to provide the service in general and who wishes to offer it in the Quick Sale service to receive purchase requests. The buyer is the person who wishes to submit a purchase offer offered through the Quick Sale service. The advertisement period is the period during which buyers can submit purchase offers. The purchase offer is a financial offer submitted by the buyer to purchase the goods advertised by the advertiser. The advertisement fee is a fee paid by the advertiser to the Ahmed Al-Muhaisni Real Estate website or application to publish the advertisement through the Quick Sale service. The offer submission fee is a fee paid by the buyer in return for submitting the purchase offer to the advertiser through the Ahmed Al-Muhaisni Real Estate website or application.",
      articleSix_2: "When you use the Quick Sale service, you understand and agree that the responsibility of the Ahmed Al-Muhaisni Real Estate website or application is limited to mediating the receipt of the purchase offer and delivering it to the advertiser and providing a means of communication between the two parties. When you display any advertisement through the Quick Sale service as an advertiser, you understand, agree and commit to bearing full responsibility for the accuracy of the data displayed and providing it to prospective buyers with complete accuracy and integrity. You bear full legal and financial responsibility in the event that any manipulation or concealment of any information about the property is proven. You pay the advertisement fee before publishing the advertisement, and the advertisement fee is refundable if the advertiser does not receive any purchase offer during the advertisement period. You are obligated to accept one of the purchase offers that exceeds the minimum price if the prospective buyer who submitted the offer does not refuse to complete the real estate transaction with respect to the property.",
      articleSix_3: "When you submit a purchase offer for any of the items offered in the quick sale service as a buyer, you understand, acknowledge, and commit that the offered price does not include real estate transaction tax if the item is real estate, or any other fees, commissions, or taxes. The offer submission fee is considered a deposit in case the advertiser and buyer agree to complete the service. The offer submission fee is refundable only in cases where the advertiser refuses or is unable to complete the sale, sells the service to another party, or there are defects or a substantial difference in the property data. The amount is refunded within 15 working days after verification. If the amount is refunded and it is proven that the buyer completed the purchase from the same advertiser within three months, then the Ahmed Al-Muhaisni Real Estate website or application has the right to claim from the buyer to recover the offer submission fee and any other fees or commissions and to charge him all legal and administrative costs.",
      articleSeven: "Article Seven: Service Provisions (Linking the User and the Service Provider)",
      articleSeven_1: "The Ahmed Al-Muhaisni Real Estate website or application is committed to respecting the privacy of users and protecting any personal information collected during the use of the website or application. The collection and use of personal information is carried out in accordance with the aforementioned terms and conditions and may include obtaining additional information from licensed third parties such as Alam, Sima, Bayan, Thiqa, Masdar, Imtaa, and Open Banking to enhance the quality and effectiveness of the services provided. This information is used to facilitate users' access to suitable financing offers and to present them clearly and effectively. The website or application is keen to share this information only with licensed and accredited entities. The user has the right to modify some of their personal information through the profile. The user agrees to the possibility of accessing, processing, and retaining this data in accordance with the terms and conditions. The website or application aims to connect customers with service providers, taking into account their credit obligations and financial solvency, and to present the available options to them.",
      articleEight: "Article Eight: Exchange of Information",
      articleEight_1: "Users’ use of this website or application constitutes implicit acceptance of the terms and conditions outlined, which form a binding contract between the two parties. The Ahmed Al-Muhaisni Real Estate website or application does not sell users’ personal data, but rather shares it with licensed entities and related parties as part of providing services. This exchange does not require obtaining additional consent after the commencement of use.",
      articleNine: "Article Nine: No Guarantees Provided",
      articleNine_1: "The user acknowledges and agrees that Ahmed Al-Muhaisni Real Estate Company and any of its affiliates or owners do not provide any warranty of any kind regarding personal information, its collection, processing, storage, protection, or the effectiveness of security measures. The user agrees that the company shall not be liable for any claims, losses, or damages resulting from access, disclosure, use, modification, or introduction of viruses or malware. The user also acknowledges that the company disclaims liability for any damage resulting from the user's failure to obtain the service or as a result of using the website or application. The company makes every effort to maintain the confidentiality of data and not disclose it except in accordance with applicable regulations.",
      articleTen: "Article Ten: Payment Provisions",
      articleTen_1: "When you pay for any service through the Ahmed Al-Muhaisni Real Estate website or application, you acknowledge and agree that the website or application has the right to refuse any refund request for any amount after payment, with the exception of reservation amounts governed by the cancellation policy. You have the right to request the transfer of real estate advertising packages to another user within five days from the date of payment. The refund of amounts after approval takes fourteen working days, and you bear any fees imposed by payment gateways or transfers when requesting a refund.",
      articleEleven: "Article Eleven: Preventive Measures",
      articleEleven_1: "In its pursuit of enhancing the level and quality of service provided to users of the Ahmed Al-Muhaisni Real Estate website or application, and in accordance with your use of these terms and conditions, you agree and grant the company the right to take any of the following actions without prior notice if it determines that you have breached the terms and conditions agreement: suspending your membership and temporarily or permanently banning you from using all or any of the website or application services, while reserving the right not to compensate you for any previously paid services; deleting all or any of the materials or content posted by the user; reporting your activities to the competent authorities; and taking any legal action against you.",

      articleTwelve: "Article Twelve: Limits of Liability",
      articleTwelve_1: "By using the Ahmed Al-Muhaisni Real Estate website or application, you understand and agree that it makes no warranties and assumes no liability in the event of the user's failure to comply with the Terms and Conditions Agreement. It is not liable for any risks, damages, consequences, or losses incurred by itself or any other party. Under no circumstances shall it be liable for any damages, including loss of data, profits, or business interruption, resulting from the use of, or inability to use, the content or services. Furthermore, it is not liable for any loss or damage resulting from software or internet malfunctions, loss of password or account, or any direct, consequential, or special loss, data loss, corruption, or damage, or any virus or technical attack affecting your devices as a result of using the website or application, or downloading content from it or from linked websites.",

      articleThirteen: "Article Thirteen: Intellectual Property Rights Policy",
      articleThirteen_1: "By sharing any content on the Ahmed Al-Muhaisni Real Estate website or application, you understand and agree to grant the website or application an unrestricted, non-revocable, non-distributable, and transferable right to copy, modify, alter, and publish that content without any restrictions. You bear the consequences of any shared content, and the website or application has the right to disclose your identity to any third party who claims that the published content constitutes a violation of intellectual property rights or privacy, and that the content does not contain defamatory, offensive, infringing, harmful, threatening, abusive, racist, or illegal material. If the content includes any personal information, its use is governed by the Privacy Policy. If you paid for or helped produce the content, the company may own that content.",

      articleFourteen: "Article Fourteen: Data Privacy Policy",
      articleFourteen_1: "By using the Ahmed Al-Muhaisni Real Estate website or application, you agree to the website or application collecting your personal information and interaction data to develop and improve services. The user acknowledges that the website or application has the right to disclose any information to the competent authorities whenever this is necessary to comply with any governmental or judicial regulation or request.",

      articleFifteen: "Article Fifteen: Amendment of the Agreement",
      articleFifteen_1: "When you use the Ahmed Al-Muhaisni Real Estate website or application, the website or application has the right to make changes to the terms from time to time without prior notice. Any amendment shall be effective immediately upon its adoption unless otherwise stated. The interpretation and implementation of these terms and conditions shall be subject to the regulations in force in the Kingdom of Saudi Arabia. In the event of any dispute, an amicable settlement shall be sought. If this is not possible, jurisdiction shall be vested in the competent courts in the city of Riyadh.",


      title_4: 'By entering and using',
      title_5: '(Ahmed Al-Muhaisni Real Estate Platform)',
      title_6: 'which you operate',
      title_7: 'Ahmed Al-Muhaisni Real Estate Company',
      title_8: 'You acknowledge and agree, without any modification, restriction or amendment, to this Terms and Conditions Agreement and any other policies governing the use of the Services.',
      title_9: 'You represent and warrant that you have the legal capacity to enter into this Agreement in accordance with all the terms and conditions contained herein.',
      title_10: 'You must read the terms and conditions every time you use',
      title_11: 'To ensure that you are aware of all current terms and conditions. Accordingly, your continued use of any of',
      title_12: 'You agree to any change in the terms and conditions.',
      title_13: 'The Terms and Conditions Agreement posted on',
      title_14: 'Designed to protect and preserve the rights of all',
      title_15: '(Ahmed Al-Muhaisni Real Estate Application Company)',
      title_16: 'And users who benefit from the services',
      title_17: 'With or without registration.',
      title_18: 'Definitions',
      title_19: ': It is a company registered in the Kingdom of Saudi Arabia and headquartered in Riyadh, Kingdom of Saudi Arabia, and manages and operates services.',
      title_20: 'The websites and applications through which Ahmed Al-Muhaisni Real Estate Application Company provides real estate and tourism marketing services, including but not limited to:',
      title_21: 'application',
      title_22: 'Ahmed Al-Muhaisni Real Estate',
      title_23: 'Saudi Arabia on the system',
      title_24: 'Saudi Arabia on Android',
      title_25: 'location',
      title_26: 'Saudi Arabia',
      title_27: 'User: is the real or legal person who accesses or uses the',
      title_28: 'To benefit from the services provided through the platform, whether with or without registration, they are collectively referred to in this agreement as "Users."',
      title_29: 'Article 1: General Provisions',
      title_30: 'The terms of this agreement are subject to all applicable laws, regulations and instructions in the Kingdom of Saudi Arabia.',
      title_31: 'If any provision of this Agreement is held to be illegal, void or unenforceable under any laws, regulations or judicial decisions, the remaining provisions and conditions of this Agreement shall remain in full force and effect, legal and enforceable in this Agreement and shall be enforceable under the laws.',
      title_32: 'Seeking',
      title_33: 'As much as possible to provide information on',
      title_34: 'With extreme accuracy, but some errors may occur from time to time, and we are not responsible for',
      title_35: 'No responsibility for any error in the information contained therein.',
      title_36: 'Article Two: Acceptable Use',
      title_37: 'When you use',
      title_38: 'You acknowledge and agree to the following:',
      title_39: 'You represent and warrant that you have the legal capacity to enter into this Agreement in accordance with all the terms and conditions contained herein.',
      title_40: 'Use the Site in your personal capacity or on behalf of a person you have the right to represent',
      title_41: '(for example, but not limited to: by agency or employment) only, and not to use',
      title_42: 'As any person you are not authorized to represent.',
      title_43: 'Ensure the accuracy of all information entered in',
      title_44: 'Whether user information or input as materials or content for sharing or advertising via',
      title_45: 'Do not share any information that you do not have the right to publish or share.',
      title_46: 'Do not copy any content from',
      title_47: 'And republish it on other sites without the consent of the content owner.',
      title_48: 'You are responsible for verifying the details of any content posted on',
      title_49: 'And confirm and ensure its accuracy and bear the responsibility of seeking the assistance of any technical specialist or obtaining legal advice before committing to any process, and bear the responsibility of ensuring that you act in good faith towards any other parties.',
      title_50: 'Pay all fees due for services',
      title_51: 'When due.',
      title_52: 'You must meet all government requirements and obligations and obtain all required licenses to benefit from the services.',
      title_53: 'Do not infringe upon any other user within',
      title_54: 'or attempt to cheat, lie, or defraud to harm any other user.',
      title_55: "Not to use any means (including, but not limited to, attempting to hide one's identity through VPN or proxy software) to violate the Terms and Conditions of",
      title_56: 'Or to bypass the preventive measures that you apply',
      title_57: 'When violating the terms and conditions or accessing content',
      title_58: 'In an unauthorized manner or to collect and obtain information and data about',
      title_59: 'Or its users and benefit from it in any way or republish it without permission.',
      title_60: 'Not to publish, distribute or upload any defamatory, offensive, infringing, harmful, threatening, abusive, tortuous, racist, morally inappropriate or other unlawful content or information.',
      title_61: 'Not to post any fictitious, speculative, false, inaccurate, misleading, deceptive, defamatory, or libelous content or materials, or comments.',
      title_62: 'Do not expose politics, international sovereignty, prominent figures, or any discussions that are not related to the services provided on',
      title_63: 'Not to infringe upon copyrights, trademarks, patents, publicity, databases or other proprietary or intellectual property rights owned by you',
      title_64: 'or licensed to',
      title_65: 'Not to impersonate (Ahmed Al-Muhaisni Real Estate Application Company, its representative, its employee, or any position that suggests that you are affiliated with',
      title_66: 'Unless you have official permission from',
      title_67: 'Prevent harm from',
      title_68: 'and indemnify it from any and all liabilities, losses, claims, expenses (including legal fees) and damages (whether direct or indirect) arising from claims resulting from your misuse of',
      title_69: ', including but not limited to any claims that include genuine allegations that you have breached this Agreement.',
      title_70: 'Bear all legal and criminal responsibility resulting from any violation by',
      title_71: '(user)',
      title_72: 'For the terms and conditions agreement.',
      title_73: 'Article Three: Provisions for the (Real Estate Advertisements) Service',
      title_74: 'When you publish any real estate advertisement on',
      title_75: 'You acknowledge and agree to the following:',
      title_76: 'Applying all relevant regulations, laws and legislation, obtaining all required licenses and permits for the property being offered, and having the legal capacity and right to advertise real estate and bear the consequences of any violation thereof.',
      title_77: 'Ensure that all information in the advertisement displayed is accurate and correct (including, but not limited to: section, classification, pictures, price, services, description, location, and any requirements or restrictions on the property), and undertake to keep this information updated at all times.',
      title_78: 'And bear the consequences of not updating it.',
      title_79: 'It is not possible to modify the type and location of the ad after it is published.',
      title_80: 'Interact and respond to user communications regarding the advertisement.',
      title_81: 'Paying the advertising commission imposed upon completion of the real estate transaction (in the event that fees are not exempt).',
      title_82: 'Article Four: Provisions for the (Real Estate Applications) Service',
      title_83: 'When you post any real estate request on',
      title_84: 'Seriousness in the real estate application and accuracy of the data entered in it.',
      title_85: 'Interact with users who want to communicate.',
      title_86: 'Do not post fake requests for any reason.',
      title_87: 'Pay any fees imposed for publishing the real estate application.',
      title_88: 'Article Five: Provisions for the service (Ahmed Al-Muhaisni Real Estate - Distinguished Client)',
      title_89: 'When you subscribe to the service',
      title_90: '(Ahmed Al-Muhaisni Real Estate)',
      title_91: 'The subscription is renewed periodically according to the activation start date.',
      title_92: 'Service features',
      title_93: 'Subject to increase or change whenever deemed necessary',
      title_94: 'That would be appropriate.',
      title_95: 'Misuse of the Service (including but not limited to: targeting Owners for marketing purposes) may result in termination of your Service without refund and without prior notice.',
      title_96: 'Search results for Aqar Plus filters are based primarily on advertiser input and do not provide...',
      title_97: 'Any guarantees about the accuracy of the information entered.',
      title_98: 'Article Six: Provisions for the (Fast Sale) Service',
      title_99: 'In this article, the following definitions are used:',
      title_100: 'flash sale',
      title_101: 'It is a service provided on:',
      title_102: 'It serves advertisers who wish to list their property with prospective buyers, and performs',
      title_103: 'Receiving purchase offers from potential buyers.',
      title_104: 'Advertiser',
      title_105: ':He is the owner of the right to dispose of the property (or his representative or the licensed real estate broker authorized to mediate this property) and who wishes to offer it in the service',
      title_106: 'To receive purchase orders.',
      title_107: 'Purchase order',
      title_108: ':A person who wishes to submit an offer to purchase a property offered through the service.',
      title_109: 'Advertisement duration',
      title_110: 'The period in which submission is available',
      title_111: 'Buy Offer',
      title_112: 'from',
      title_113: 'It is a financial offer submitted by',
      title_114: 'To purchase the property advertised previously',
      title_115: 'Advertising fees',
      title_116: 'It is a fee paid by',
      title_117: 'For',
      title_118: 'To publish an advertisement via the service',
      title_119: 'in',
      title_120: 'Presentation fees',
      title_121: 'In exchange for offering',
      title_122: 'For the advertiser',
      title_123: 'via',
      title_124: 'When you use the service',
      title_125: 'You understand and agree that:',
      title_126: 'responsible',
      title_127: 'Limited to mediating receipt',
      title_128: 'And deliver it',
      title_129: 'Providing a means of communication between the two parties.',
      title_130: 'When displaying any',
      title_131: 'advertisement',
      title_132: 'Via service',
      title_133: 'As you',
      title_134: 'advertiser,',
      title_135: 'You understand, agree and undertake to the following:',
      title_136: 'You bear full responsibility for the accuracy and availability of the property data displayed.',
      title_137: 'For purchasers',
      title_138: 'With complete accuracy and integrity, you bear full legal and financial responsibility in the event that any tampering or concealment of any information about the property being offered is proven.',
      title_139: 'Your push',
      title_140: 'To draw the advertisement',
      title_141: 'Before posting the ad.',
      title_142: 'Refundable if not received',
      title_143: 'any',
      title_144: 'during',
      title_145: 'through',
      title_146: 'Your commitment to accept someone',
      title_147: 'Purchase offers',
      title_148: 'Exceeding the minimum price in the event of non-abstention',
      title_149: 'Who made the offer to complete the real estate transaction.',
      title_150: 'When submitting',
      title_151: 'For any property offered in the service',
      title_152: 'Purchase request',
      title_153: 'You understand, acknowledge and agree to the following:',
      title_154: 'The price offered in',
      title_155: 'It is the price of the property and does not include the real estate transaction tax or any other fees, commissions or taxes.',
      title_156: 'The bid submission fee is considered.',
      title_157: 'A deposit in advance if agreed',
      title_158: 'and',
      title_159: 'the buyer',
      title_160: 'To complete the real estate transaction.',
      title_161: 'Bid submission fee',
      title_162: 'Refundable only in the following cases:',
      title_163: 'to reject',
      title_164: 'Or his inability to complete the sale to the buyer.',
      title_165: 'Selling the property to another party',
      title_166: 'The discovery of a serious flaw in the property data or the concealment of essential information.',
      title_167: 'The amount will be returned',
      title_168: 'Bid submission fee',
      title_169: 'Within 15 working days of verifying the reason for the return.',
      title_170: "To the purchaser's bank account or payment card used in the payment process",
      title_171: 'In case of refund',
      title_172: 'And it is proven that',
      title_173: 'Complete the property purchase process from the same',
      title_174: 'Within (3) months of its display in',
      title_175: 'Then for',
      title_176: 'Right of recourse',
      title_177: 'the buyer',
      title_178: 'To recover the submission fee and any other fees or commissions due to (',
      title_179: 'And bear all legal and administrative costs of claiming these amounts.',
      title_180: 'Article Seven: Provisions for the (daily reservation) service',
      title_181: 'In this article, the following definitions are used:',
      title_182: 'Daily booking',
      title_183: 'Serves landlords who wish to display their available units for short-term or tourist rentals, and tenants who are searching for available units for short-term or tourist rentals.',
      title_184: 'The landlord',
      title_185: ':A natural or legal person who provides hospitality services or short-term rental units.',
      title_186: 'tenant',
      title_187: ': A natural or legal person who benefits from hospitality services or short-term rental units.',
      title_188: '',
      title_189: '',
      title_190: '',
      title_191: '',
      title_192: '',
      title_193: '',
      title_194: '',
      title_195: '',
      title_196: '',
      title_197: '',
      title_198: '',
      title_199: '',
      title_200: '',
    },

    formSuccess: {
      title_1: "Data uploaded successfully",
      title_2: "The advertising department will contact you within 24 hours.",
      title_3: "To complete your advertisement successfully through us",
      we_willContact: "We will contact you to complete the order.",
      title_4: "Back to Home",
    },

    createfinance: {
      breadcrumb_1: 'Home',
      breadcrumb_2: 'Real Estate financing application',
      title_1: "Real Estate financing data",
      title_2: "Full name",
      title_3: "Mobile number",
      title_4: "Your net monthly income (salary)",
      title_5: "The Amount",
      title_6: "List your obligations in full.",
      title_7: "Submit a real estate financing application",
      title_8: "Your mortgage application has been received.",
      // title_9: "Your mortgage",
      // title_10: "Reserve the property to ensure it stays with you until we prepare your application.",
      // title_11: "We will process your request and contact you soon, keep it up.",
      finace_P: "The team will review it and contact you soon, and you can continue to book the property until the procedures are completed.",
      title_12: "",
    },

    rentalDetails: {
      breadcrumb_1: 'Home',
      breadcrumb_2: 'Property details',
      title_1: 'Property condition',
      title_2: 'Rental details',
      title_4: 'Remaining payments',
      title_5: 'Full rental term',
      title_6: 'Next payment date',
      title_7: 'Late payments',
      title_8: 'Rent expiration date',
      title_9: 'the Site',
      title_10: 'Financing application',
      title_11: 'Maintenance request',
      title_12: "Return to main page",
      propertyDetails: "Property details",
      paid: "Paid",
      PropertyManager: "Property Manager",
      Ahmed_AlMuhaisni_Company: "Ahmed Al-Muhaisni Real Estate Company",
      backToHome: "Back to home",
      installmentDue: "The installment due was successfully paid.",
      upcomingPayments: "Upcoming payments:",
      dueDate: "due date:",
      PayingRent: "Paying the rent",
      totalUnits: "Total units",
      vacancies: "Vacancies",
      landlord: "Landlord",
      sold: "Sold",
    },

    photographyDetails: {
      breadcrumb_1: 'Home',
      breadcrumb_2: 'Professional property photography',
      breadcrumb_3: 'Updates',
      Cancel_Order_Button: 'Cancel order',
      title_1: 'Cancel order',
      title_2: 'Reasons for order cancellation',
      title_3: 'Choose a reason for order cancellation',
      payOrder: "Pay the order",
      cancel_photorequest: "Cancel photo request",
    },

    photography: {
      breadcrumb_1: 'Home',
      breadcrumb_2: 'Add advertisement',
      breadcrumb_3: 'professional photography Request',
      title_1 : "Don't just list your property, tell its story!",
      title_2 : "Professional photography makes it the most sought-after.",
      title_3 : "and closes the deal quickly.",
      button_nextStep: "professional photography Request",
      fullName: "Full name",
      name_placeholder: "Enter your full name",
      phoneNumber: "Phone number",
      mobile_placeholder: "Enter phone number",
      region: "Region",
      city: "City",
      fullAddress: "Full address",
      location: "Location on the map",
      package: "Choosing the right package",
      button_Payment: "Payment and order submission",
      requestReceived: "Your request has been received",
      contactedSoon: "You will be contacted soon to arrange a photoshoot with a professional photographer.",
    },

    lawyerRequested: {
      breadcrumb_1: 'Home',
      breadcrumb_2: 'Contact your lawyer',
      fullName: "Full Name",
      enter_Fullname: "Write your name here.",
      phoneNumber: "phone number",
      enterPhoneNumber: "Enter phone number",
      consultationDescription: "Consultation description",
      detailsInquiry: "Write the details of your legal inquiry.",
      Submitrequest: "The request will be sent in complete confidentiality.",
      successfullySubmitted: "Your request for legal advice has been successfully submitted; we will contact you soon.",
      attachDocuments: "Attach documents (optional)",
    },

    lawyerDetails: {
      breadcrumb_1: 'Home',
      breadcrumb_2: 'Contact your lawyer',
      fullName: "Full name",
      mobile: "Mobile number",
      description: "Consultation description",
      comments: "Comments and updates",
    },

    advertismentReport: {
      breadcrumb_1: 'Home',
      breadcrumb_2: "Report this advertisment",
      reason: "the reason",
      writeReport: "Write the text of the report",
      btnConfrim: "Confrim",
      btnCancel: "Cancel",
      succes: "We have received your report and are currently investigating it.",
    },

    propReservationDetails: {
      breadcrumb_1: 'Home',
      breadcrumb_2: "My reservations",
      breadcrumb_3: "prop Reservation Details",
    },

    businessTransferDetails: {
      breadcrumb_1: "Home",
      breadcrumb_2: "Business transfer details",
      Advertisementdetails: "Advertisement details",
      ActivityDescription:  "Activity description",
      Reason: "Reason business transfer details",
      assetsList: "Origins and Existences",
      listofassets: "A list of assets within your project (equipment, appliances, furniture, decor, operating license, etc.)",
      FixedAsset: "Fixed asset condition",
      financialObligations: "There are financial obligations or debts",
      ProjectStrengths: "Project strengths",
      projectWeaknesses: "Project weaknesses",
      projectAge: "Project age",
      remainingTerm: "Remaining rent contract duration",
      floorsCount: "Floors count",
      officesCount: " Offices count",
      hallsCount: "Halls count",
      parkingCount: "Parking count",
      projectArea: "Project area",
      square: "m 2",
      View: "View",
      doorsCount: "Doors count",
      roomsCount: "Rooms count",
      bathroomsCount: "Bathrooms count",
      applicant: "Applicant",
      reservePreview: "Reserve preview",
      totalPrice: "Total price",
    },

    contactUs: {
      breadcrumb_1: "Home",
      breadcrumb_2: "Contact us",
      name: "Name",
      communication: "Mobile",
      description: "Subject",
      uploadingImages: "Attach an images (optional)",
      send: "send",
      receivedDetails: "Thank you, we have received your details and will contact you as soon as possible.",
      btn_submit: "Back to home"
    },

    login: {
      title_1: "Login",
      title_2: "Mobile Number",
      title_3: "Enter Mobile Number",
      title_4: "Password",
      title_5: "Enter Password",
      title_6: "Forgot your password?",
      title_7: "Don't have an account?",
      title_8: "Create a new account",
      title_9: "Nafath ",
    },
    

    formLogin: {
      title_1: "You must be logged in.",
      title_2: "You must log in to",
      title_3: "Your account / Create a new account via Nafath",
      title_4: "Login",
      title_5: "Create a new account by",
      title_6: "Nafath",
    },

    register: {
      title_1: "Create a new account",
      title_2: "Full name",
      title_3: "Mobile Number",
      title_4: "ID Number",
      title_5: "Password",
      title_6: "Account Registration",
      title_7: "Already have an account?",
      title_8: "Login",
      title_9: "Click after approval from Nafath",
      title_10: "Enter the variable access code",
      title_11: "The code has been sent.",
      title_12: "Mobile Number",
      title_13: "Enter your name here",
      title_14: "Enter your mobile number",
      title_15: "Enter ID Number",
      already_login: "You are already registered with us, thank you.",
      installText: "Please download the app and then click the link again. Thank you.",
    },
    
    footer:{
      title_1: 'Follow us here',
      title_2: 'All copyrights reserved to Ahmed Al-Muhaisni Real Estate Company',
      title_3: 'Who we are',
      title_4: 'Home',
      title_5: 'Frequently Questions',
      title_6: 'Terms Conditions',
      privacyPolicy: "Privacy Policy",
      contactUs: "Contact us",
      complaints: "Complaints reports",
    },

    privacyPolicy: {
      breadcrumb_1: "Home",
      breadcrumb_2: "privacy policy",
      Website: "Ahmed Al Muhaysini Real Estate application and website (Aqar Almuhaysini)",
      lastUpdate: "Last Updated: January 15, 2026",
      scopePolicy: "1. Scope of this Policy",
      scopePolicy_P: "This policy explains how we collect, use, and protect the personal data of users when using the Ahmed Al-Muhaisni Real Estate app and website, aqaralmuhaysini.com. This includes owners, tenants, buyers, brokers, service providers, and visitors.",
      dataCollect: "2. Data We Collect",
      dataCollect_T: "We may collect the following types of data:",
      dataCollect_l1: "a) Identity Data: Name, ID or Commercial Registration Number, Mobile Number, Email Address.",
      dataCollect_l2: "b) Property and Transaction Data: Ownership or authorization data, property unit data, rental or sale requests, negotiation records, and offers.",
      dataCollect_l3: "c) Usage Data: Order history, in-app conversations, recorded calls made through the platform, approximate geographic location, IP address.",
      dataCollect_l4: "d) Payment Data: Collection data, invoice history, and commissions. These are processed through licensed payment providers, and we do not store card data. 3. Purpose of Data Collection",
      National_ID: "National ID Number (identity) : A fundamental requirement used to verify a person's data through the Nafath platform (a government entity) and to verify the advertising license number when adding a property.",
      Mobile_Number: "Mobile Number: A fundamental requirement used during new user registration. A verification code is sent to the mobile number to confirm that the person registering is indeed the owner of the mobile number.",
      purposeData: "3. Purpose of data collection",
      purposeData_P: "The data is used to carry out brokerage, leasing and selling operations, property management and maintenance, documentation of operations and contracts, collection and payment, compliance with regulations and official bodies, improving service quality, resolving disputes and proving rights.",
      LegalBasis: "4. Legal Basis for Processing",
      LegalBasis_P: "Data is processed based on user consent during registration, in execution of a contract or request, in compliance with the Kingdom's regulations, and for the legitimate interest of the platform management, in accordance with the Saudi Personal Data Protection Law.",
      dataSharing: "5. Data Sharing",
      dataSharing_P: "Data may be shared with relevant government entities such as the Real Estate Authority, Ejar, and judicial authorities, as well as with service providers such as maintenance, electronic payment, and documentation providers, and with authorized partners within the platform. Data is not sold or leased to any third party.",
      dataStorage: "6. Data Storage and Protection",
      dataStorage_P: "We are committed to taking technical and organizational measures to protect data from breaches, manipulation, loss, or unauthorized use. Data is stored within secure systems that comply with SDAIA requirements.",
      retentionPeriod: "7. Retention Period",
      retentionPeriod_P: "We retain data as long as the account is active, required for legal purposes, or for the purposes of proving rights or resolving disputes. Data is deleted or hidden after the legal purpose is fulfilled.",
      userRights: "8. User Rights",
      userRights_P: "Users have the right to request access to their data, request its correction, request its deletion unless required by law, withdraw their consent, and file a complaint with SDAIA via email at",
      recordingCalls: "9. Recording of Calls and Conversations",
      recordingCalls_P: "When using the in-app call or chat features, the user acknowledges their consent to recording for documentation, quality assurance, and proof of rights purposes. This recording will not be used for any other purpose.",
      Amendments: "10. Amendments",
      Amendments_P: "The company reserves the right to update this policy. Continued use of the platform constitutes acceptance of these updates.",
      Responsible: "11. Responsible Party",
      Responsible_P: "Ahmed Al-Muhaisni Real Estate Company, Kingdom of Saudi Arabia, website:",
      brokersMobile: "The broker's mobile number is incorrect.",
    },

    privacyProvider: {
      breadcrumb_1: "Home",
      breadcrumb_2: "Privacy Policy for Aqar Almuhaysini provider App",
      lastUpdated: "Last Updated: (25/1/2026)",
      aqarAlmuhaysini_provider_App: "The Aqar Almuhaysini provider App is committed to protecting the privacy of its users from service providers and maintains the confidentiality and security of all personal data collected or processed, in accordance with the laws and regulations in force in the Kingdom of Saudi Arabia.",
      byUsing_App: "By using the app, you acknowledge and agree to this Privacy Policy and all its provisions.",
      Information_WeCollect: "First: Information We Collect",
      personalInformation: "1. Personal Information",
      followingInformation: "We may collect some or all of the following information:",
      fullName: "Full Name",
      mobileNumber: "Mobile Number",
      emailAddress: "Email Address",
      nationalID: "National ID Number (when required for verification)",
      profilePicture: "Profile Picture",
      bankAccount_Details: "Bank Account Details (for payment purposes)",
      serviceProvider_Information: "2. Service Provider Information",
      typeService: "Type of Service Provided (Plumbing, Electrical, Maintenance, Photography, etc.)",
      scopeWork: "Scope of Work and Served Areas",
      availabilityTimes: "Availability Times",
      offersPrices: "Offers and Prices",
      historyCompleted : "History of Completed or Pending Orders",
      locationInformation: "3. Location Information",
      providerLocation: "The application may request access to the provider's location:",
      duringOrder: "During order receipt and fulfillment",
      propertyLocation: "To direct the provider to the property location",
      locationTracking: "Location tracking is not continuous or in the background without a clear operational need.",
      technicalInformation: "4.Technical Information",
      deviceType: "Device Type and Operating System",
      internetProtocol: "Internet Protocol (IP) Address",
      usageData: "In-App Usage Data",
      performanceImprovement: "Crash Logs and Performance Improvement",
      howInformation: "Second: How the Information",
      collectedInformation: "The collected information is used for the following purposes:",
      operating_TheApplication: "Operating the application and managing service provider accounts",
      connectingProviders: "Connecting providers with appropriate requests",
      organizingScheduling: "Organizing and scheduling maintenance work",
      Communicating: "Communicating regarding requests or updates",
      verifyingIdentity: "Verifying identity and preventing unauthorized use",
      processingPayments: "Processing payments and financial dues",
      improvingService: "Improving service quality and user experience",
      Complying: "Complying with official regulations and instructions",
      Third_SharingInformation: "Third: Sharing Information",
      Almuhaysini_Provider_application: "The Aqar Almuhaysini provider application does not sell or rent personal data to any third party.",
      data_maybe_Shared: "Some data may be shared only in the following cases:",
      clients: "With clients for the purpose of fulfilling the requested service",
      electronic: "With electronic payment service providers",
      technicalPartners: "With technical partners (hosting, technical support) for operational purposes",
      governmentEntities: "With government entities upon formal request",
      Sharing: "Sharing will be limited to the minimum scope necessary to achieve the required purpose.",
      Fourth_InformationProtection: "Fourth: Information Protection",
      committedTaking: "We are committed to taking appropriate technical and organizational measures to protect data, including:",
      dataEncryption: "Data encryption",
      systemsPrevent: "Systems to prevent unauthorized access",
      restrictingAccess: "Restricting access to authorized personnel only",
      acknowledges: "However, the user acknowledges that data transmission over the internet cannot be guaranteed 100%.",
      Fifth_DataRetention: "Fifth: Data Retention",
      dataRetained: "Data is retained as long as the provider's account is active or as required by regulatory and operational requirements. Data is deleted or hidden when its purpose is fulfilled, unless there is a regulatory obligation to retain it.",
      Sixth_ServiceProvider: "Sixth: Service Provider Rights",
      serviceProvider: "The service provider has the right to:",
      personalData: "Access their personal data",
      update_Accountinformation: "Modify or update account information",
      requestAccount: "Request account suspension",
      revoke_Certainprivileges: "Revoke certain privileges (noting that this may affect service provision)",
      applicationAdministration: "These rights can be exercised through the application settings or by contacting the application administration.",
      Seventh_CookiesSimilar_Technologies: "Seventh: Cookies and Similar Technologies",
      analytical_Technologiesimprove: "The application may use analytical technologies to improve performance and user experience without compromising personal privacy or using data for unauthorized advertising purposes.",
      privacyPolicy: "Eighth: Privacy Policy",
      application_Notintended: "This application is not intended for users under the age of 18, and no data is intentionally collected from minors.",
      amendments_PrivacyPolicy: "Ninth: Amendments to the Privacy Policy",
      amend_PrivacyPolicy: "The Aqar Almuhaysini provider application reserves the right to amend this Privacy Policy as needed. Users will be notified of any significant amendments through the application or its approved communication channels.",
      application_Afteramendments: "Continued use of the application after amendments constitutes implicit acceptance of the amended policy.",
      tenth_Contactingus: "Tenth: Contacting Us",
      pleaseContactus: "For inquiries or requests related to the Privacy Policy, please contact us via:",
      email: "Email",
      phoneNumber: "Phone Number:  920016962",
    },

    complaints: {
      breadcrumb_1: "Home",
      complaintsReports: "Complaints and Reports",
      Ahmed_AlMuhaisni_RealEstate: "Ahmed Al-Muhaisni Real Estate Company is committed to enabling all users to submit complaints or reports related to services or content within the platform. These complaints are handled in accordance with the regulations in force in the Kingdom of Saudi Arabia.",
      submittingComplaint: "Submitting a Complaint",
      complaints_can_Submitted: "Complaints can be submitted via the website or application form, by email, or through the “Contact Us” page.",
      contactUs: "“Contact Us”",
      processingResponse: "Processing and Response",
      complaints_are_reviewed: "Complaints are reviewed within five business days, and the complainant will be contacted if necessary.",
      Escalation: "Escalation",
      complaint_the_General: "Users have the right to escalate a complaint to the General Authority for Real Estate or the relevant authority if they are dissatisfied with the outcome.",
      scope_Liability: "Scope of Liability",
      companyLiability: "The company's liability is limited to platform services and does not extend to direct contractual disputes between parties.",
      Abuse: "Abuse",
      companyReserves: "The company reserves the right to close malicious or erroneous complaints.",
      complaint_Handling_Mechanism: "Complaint Handling Mechanism",
      receivingComplaint: "Receiving a ComplaintThe complaint is registered immediately upon receipt in the designated system.",
      reviewing_theComplaint: "Reviewing the Complaint",
      specializedTeam: "The specialized team reviews the complaint and verifies its details within a period not exceeding three business days.",
      communicatingParties: "Communicating with Parties",
      whenNecessary: "When necessary, the user, service provider, or any relevant party will be contacted to obtain additional information or verify the facts.",
      actionTaken: "Action Taken",
      appropriateAction: "Appropriate action will be taken in accordance with the platform's policies and terms, and may include: notifying the user or service provider, suspending or modifying the advertisement, temporarily or permanently suspending the account, or dismissing the complaint if it is not substantiated.",
      notificationComplainant: "Notification of Complainant",
      complainant_notified: "The complainant will be notified of the outcome of the process within a period not exceeding ten business days from the date of receipt.",
    },

    containerRet: {
      latePayments: "Late payments",
      unitsProperty: "Units within the property",
      rentalName: "Property tenant",
      propertyStatus: "Property status",
      propertyDetails: "Unit details",
    },
    nafath: {
      linkTitle: 'Verify your account',
      cardTitle: 'Account verification',
      wellcome: 'Welcome',
      verfiyText: 'Please verify your account through the Nafath platform to enjoy the benefits of the Ahmed Al-Muhaisni Real Estate company.',
      identity: 'ID/Residence number',
      submit: 'submit',
      identityRequired: 'The ID number must be entered',
      identityIncorrect: 'Incorrect ID number',
      alreadVerified: 'Your account is verified via Nafath. Thank you.',
      nafathExplain: 'The invitation has been sent to you. Please go to the Nafath app, accept the invitation, select the number below, and then click "Invitation Accepted".',
      checkNow: 'Invitation Accepted',
      notNow: 'Later',
      mustVerify: 'You must verify your account through the Nafath app in order to access the services of Ahmed Al-Muhaisni Real Estate company.',
    },
    businessTransferUpdate: {
      ProjectData: "Project data modification",
      successfullyModified: "The business Transfer request was successfully modified.",
      saveChanges: "Save changes",
    },
    mySubscription: {
      breadcrumb_1: "Home",
      breadcrumb_2: "My Subscription",
      propertiesStand: "Make your property management more efficient and transparent",
      customerService: "Leasing and tracking your properties through a professional system based on clear performance indicators:",
      fastestCustomer: "Customer service response time: Quick",
      lowerCommission: "Property management: 15% discount on the annual percentage rate (APR)",
      Faster_Stronger: "Free listing: Property published within 24 hours",
      accountManager: "Rental time: Average (to be determined) days",
      forgiveness_Contract: "Dedicated relationship manager: Available from 9 AM to 9 PM (6 days a week)",
      reducedMaintenance: "Contract signing fees: SAR 0 (office fees waived)",
      freeProperty: "Property valuation: Free within 48 hours",

      subscribeNow: "Subscribe now for",
      subscribeNowt: "SAR per month",
      subscriptionSuccessful: "Subscription successful!",
      congratulations: "Congratulations! Now enjoy all the benefits of your subscription.",
      returnMain: "Return Main page",
      terminationDate: "Subscription termination date",
      SubscriptionFee: "Subscription fee",
      renewSubscription: "Renew subscription",
      distinguishedOwner: "You are already a special owner",
    }
  },
};


export default English;